// Auto-generated from BMS_Data_Final_27032026.xlsx — do not edit manually
// Generated on: 2026-04-07T08:53:24.713Z

import axios from 'axios';
import { appUrl } from '../../../../../../utils/config';
import { getApiBaseUrl } from '../../CommonMethods/CommonMethods';

const apiBaseUrl = getApiBaseUrl(appUrl);

// ===== DROPDOWN OPTIONS APIs =====

export const fetchAllProjectIdsAPI = async () => {
  return {
    status: true,
    data: ["13762","6280"],
  };
};

export const fetchStagesForProjectAPI = async (projectId) => {
  return {
    status: true,
    data: ["Stage C"],
  };
};

export const fetchCampaignsForProjectAPI = async (projectId, stageId) => {
  const all = ["CMPO04BRS729 / DBSQC25001","CMPO04BRS729 / DBSQC26001","CMPO04BRS729 / DBSQC26002","CMPO04TEV169 / DBSQC26003","CMPO04BRS729 / DBSQC26004","CMPO04TEV169 / DBSQC26005","CMPO04BRS729 / DBSQC26006","CMPO04TEV169 / DBSQC26007","CMPO04BRS729 / DBSQC26008","CMPO04BRS729 / DBSQC26009","CMPO04BRS729 / DBSQC26010","CMPO04BRS729 / DBSQC26011","CMPO04BRS729 / DBSQC26012"];
  return { status: true, data: all };
};

// ===== ANALYTICS TABS API =====

export const fetchProjectAnalyticsTabsAPI = async (projectId, stageId, campaignId) => {
  return {
    status: true,
    data: {
      tabs: [
        {
          id: 1,
          name: 'Batch Yield',
          hasFilters: false,
          columns: [
            { id: 1, name: 'Campaign / Batch', field: 'campaignBatch' },
            { id: 2, name: 'Actual Product Qty', field: 'actualProductQuantity' },
            { id: 3, name: 'Expected Product Qty', field: 'expectedProductQuantity' },
            { id: 4, name: 'UOM', field: 'uom' },
            { id: 5, name: 'Yield', field: 'yield' },
            { id: 6, name: 'Batch Mfg Date', field: 'batchManufacturingDate' },
            { id: 7, name: 'Expiry Date', field: 'expiryDate' },
            { id: 8, name: 'Storage Condition', field: 'storageCondition' },
            { id: 9, name: 'Storage Location', field: 'storageLocation' },
          ],
          rows: [
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "actualProductQuantity": "81.1",
                    "expectedProductQuantity": "170",
                    "uom": "Kg",
                    "yield": "47.71%",
                    "batchManufacturingDate": "16-JAN-2026",
                    "expiryDate": "",
                    "storageCondition": "",
                    "storageLocation": "Unit-IV",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "actualProductQuantity": "233.46",
                    "expectedProductQuantity": "390",
                    "uom": "Kg",
                    "yield": "59.86%",
                    "batchManufacturingDate": "16-FEB-2026",
                    "expiryDate": "",
                    "storageCondition": "",
                    "storageLocation": "Unit-IV",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26002",
                    "actualProductQuantity": "0",
                    "expectedProductQuantity": "390",
                    "uom": "Kg",
                    "yield": "",
                    "batchManufacturingDate": "",
                    "expiryDate": "",
                    "storageCondition": "",
                    "storageLocation": "Unit-IV",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26002"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "actualProductQuantity": "57.36",
                    "expectedProductQuantity": "100",
                    "uom": "Kg",
                    "yield": "57.36%",
                    "batchManufacturingDate": "28-FEB-2026",
                    "expiryDate": "",
                    "storageCondition": "",
                    "storageLocation": "Unit-IV",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26004",
                    "actualProductQuantity": "110.48",
                    "expectedProductQuantity": "200",
                    "uom": "Kg",
                    "yield": "55.24%",
                    "batchManufacturingDate": "28-FEB-2026",
                    "expiryDate": "",
                    "storageCondition": "",
                    "storageLocation": "Unit-IV",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26004"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26005",
                    "actualProductQuantity": "60.76",
                    "expectedProductQuantity": "100",
                    "uom": "Kg",
                    "yield": "60.76%",
                    "batchManufacturingDate": "02-MAR-2026",
                    "expiryDate": "",
                    "storageCondition": "",
                    "storageLocation": "Unit-IV",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26005"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26006",
                    "actualProductQuantity": "110.6",
                    "expectedProductQuantity": "200",
                    "uom": "Kg",
                    "yield": "55.30%",
                    "batchManufacturingDate": "08-MAR-2026",
                    "expiryDate": "",
                    "storageCondition": "",
                    "storageLocation": "Unit-IV",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26006"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26007",
                    "actualProductQuantity": "55.08",
                    "expectedProductQuantity": "100",
                    "uom": "Kg",
                    "yield": "55.08%",
                    "batchManufacturingDate": "08-MAR-2026",
                    "expiryDate": "",
                    "storageCondition": "",
                    "storageLocation": "Unit-IV",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26007"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "actualProductQuantity": "190.02",
                    "expectedProductQuantity": "360",
                    "uom": "Kg",
                    "yield": "52.78%",
                    "batchManufacturingDate": "12-MAR-2026",
                    "expiryDate": "",
                    "storageCondition": "",
                    "storageLocation": "Unit-IV",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26009",
                    "actualProductQuantity": "120.44",
                    "expectedProductQuantity": "220",
                    "uom": "Kg",
                    "yield": "54.75%",
                    "batchManufacturingDate": "17-MAR-2026",
                    "expiryDate": "",
                    "storageCondition": "",
                    "storageLocation": "Unit-IV",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26009"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26010",
                    "actualProductQuantity": "205.7",
                    "expectedProductQuantity": "380",
                    "uom": "Kg",
                    "yield": "54.13%",
                    "batchManufacturingDate": "20-MAR-2026",
                    "expiryDate": "",
                    "storageCondition": "",
                    "storageLocation": "Unit-IV",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26010"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26011",
                    "actualProductQuantity": "128.02",
                    "expectedProductQuantity": "220",
                    "uom": "Kg",
                    "yield": "58.19%",
                    "batchManufacturingDate": "24-MAR-2026",
                    "expiryDate": "",
                    "storageCondition": "",
                    "storageLocation": "Unit-IV",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26011"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26012",
                    "actualProductQuantity": "112.54",
                    "expectedProductQuantity": "205",
                    "uom": "Kg",
                    "yield": "54.90%",
                    "batchManufacturingDate": "26-MAR-2026",
                    "expiryDate": "",
                    "storageCondition": "",
                    "storageLocation": "Unit-IV",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26012"
          }
],
        },
        {
          id: 2,
          name: 'In-Process Tests',
          hasFilters: false,
          columns: [
            { id: 1, name: 'Campaign / Batch', field: 'campaignBatch' },
            { id: 2, name: 'Method Number', field: 'methodNumber' },
            { id: 3, name: 'Method Name', field: 'methodName' },
            { id: 4, name: 'Sample ID', field: 'sampleID' },
            { id: 5, name: 'Specification Limit', field: 'specificationLimit' },
            { id: 6, name: 'Analytical Report Number', field: 'analyticalReportNumber' },
            { id: 7, name: 'Result Value', field: 'resultValue' },
            { id: 8, name: 'Result', field: 'result' },
            { id: 9, name: 'UOM', field: 'uom' },
          ],
          rows: [
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-B",
                    "sampleID": "D/IM/25/12/0957",
                    "sampleDescription": "DIP25121105",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP25121105",
                    "resultValue": "0.0004",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity of Stage-C.",
                    "sampleID": "D/IM/25/12/0957",
                    "sampleDescription": "DIP25121105",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP25121105",
                    "resultValue": "0.744",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/01/0190",
                    "sampleDescription": "DIP26010222",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26010222",
                    "resultValue": "0.05 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity",
                    "sampleID": "D/IM/26/01/0337",
                    "sampleDescription": "DIP26010484",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26010484",
                    "resultValue": "0.943",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of benzophenone hydrazine",
                    "sampleID": "D/IM/26/01/0337",
                    "sampleDescription": "DIP26010484",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26010484",
                    "resultValue": "0.037",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-C dimer impurity",
                    "sampleID": "D/IM/26/01/0337",
                    "sampleDescription": "DIP26010484",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26010484",
                    "resultValue": "0.0017",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity",
                    "sampleID": "D/IM/26/01/0765",
                    "sampleDescription": "DIP26010843",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26010843",
                    "resultValue": "0.968",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of benzophenone hydrazine",
                    "sampleID": "D/IM/26/01/0765",
                    "sampleDescription": "DIP26010843",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26010843",
                    "resultValue": "0.0071",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-C dimer impurity",
                    "sampleID": "D/IM/26/01/0765",
                    "sampleDescription": "DIP26010843",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26010843",
                    "resultValue": "0.0017",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/01/0836",
                    "sampleDescription": "DIP26010925",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26010925",
                    "resultValue": "1.7 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/01/0870",
                    "sampleDescription": "DIP26010951",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26010951",
                    "resultValue": "0.45 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/01/1266",
                    "sampleDescription": "DIP26011409",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26011409",
                    "resultValue": "0.06 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Hydrazine in Stage-C filtrate mL’s by GC-HS (ppm)",
                    "sampleID": "D/IM/26/01/1357",
                    "sampleDescription": "DIP26011507",
                    "specificationLimit": "Not more than 200",
                    "analyticalReportNumber": "DIP26011507",
                    "resultValue": "2.5 ppm",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "ppm",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-B",
                    "sampleID": "D/IM/26/01/1361",
                    "sampleDescription": "DIP26011511",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26011511",
                    "resultValue": "0.0006",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity of Stage-C.",
                    "sampleID": "D/IM/26/01/1361",
                    "sampleDescription": "DIP26011511",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26011511",
                    "resultValue": "0.726",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity",
                    "sampleID": "D/IM/26/02/0124",
                    "sampleDescription": "DIP26020174",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26020174",
                    "resultValue": "0.891",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of benzophenone hydrazine",
                    "sampleID": "D/IM/26/02/0124",
                    "sampleDescription": "DIP26020174",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26020174",
                    "resultValue": "0.072",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-C dimer impurity",
                    "sampleID": "D/IM/26/02/0124",
                    "sampleDescription": "DIP26020174",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26020174",
                    "resultValue": "Not Detected",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity",
                    "sampleID": "D/IM/26/02/0605",
                    "sampleDescription": "DIP26020687",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26020687",
                    "resultValue": "0.965",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of benzophenone hydrazine",
                    "sampleID": "D/IM/26/02/0605",
                    "sampleDescription": "DIP26020687",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26020687",
                    "resultValue": "0.006",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-C dimer impurity",
                    "sampleID": "D/IM/26/02/0605",
                    "sampleDescription": "DIP26020687",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26020687",
                    "resultValue": "Not Detected",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/02/0990",
                    "sampleDescription": "DIP26021107",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26021107",
                    "resultValue": "5.6 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/02/1031",
                    "sampleDescription": "DIP26021147",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26021147",
                    "resultValue": "5.5 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/02/1051",
                    "sampleDescription": "DIP26021171",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26021171",
                    "resultValue": "5.8 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/02/1069",
                    "sampleDescription": "DIP26021197",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26021197",
                    "resultValue": "5.6 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/02/1115",
                    "sampleDescription": "DIP26021243",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26021243",
                    "resultValue": "5.4 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/02/1146",
                    "sampleDescription": "DIP26021267",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26021267",
                    "resultValue": "5.0 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/02/1181",
                    "sampleDescription": "DIP26021293",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26021293",
                    "resultValue": "5.3 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/02/1234",
                    "sampleDescription": "DIP26021351",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26021351",
                    "resultValue": "2.2 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/02/1315",
                    "sampleDescription": "DIP26021440",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26021440",
                    "resultValue": "0.05 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26004",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/02/1415",
                    "sampleDescription": "DIP26021545",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26021545",
                    "resultValue": "0.04 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26004"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26004",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/02/1459",
                    "sampleDescription": "DIP26021590",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26021590",
                    "resultValue": "0.06 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26004"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-B",
                    "sampleID": "D/IM/26/02/1485",
                    "sampleDescription": "DIP26021654",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26021654",
                    "resultValue": "0.0006",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity of Stage-C.",
                    "sampleID": "D/IM/26/02/1485",
                    "sampleDescription": "DIP26021654",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26021654",
                    "resultValue": "0.774",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26004",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-B",
                    "sampleID": "D/IM/26/02/1568",
                    "sampleDescription": "DIP26021774",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26021774",
                    "resultValue": "0.0001",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26004"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26004",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity of Stage-C.",
                    "sampleID": "D/IM/26/02/1568",
                    "sampleDescription": "DIP26021774",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26021774",
                    "resultValue": "0.691",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26004"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity",
                    "sampleID": "D/IM/26/02/1664",
                    "sampleDescription": "DIP26021895",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26021895",
                    "resultValue": "0.973",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of benzophenone hydrazine",
                    "sampleID": "D/IM/26/02/1664",
                    "sampleDescription": "DIP26021895",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26021895",
                    "resultValue": "0.0091",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-C dimer impurity",
                    "sampleID": "D/IM/26/02/1664",
                    "sampleDescription": "DIP26021895",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26021895",
                    "resultValue": "0.0011",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/02/1874",
                    "sampleDescription": "DIP26022031",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022031",
                    "resultValue": "2.4 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26005",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/02/1875",
                    "sampleDescription": "DIP26022032",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022032",
                    "resultValue": "0.07 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26005"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/02/1898",
                    "sampleDescription": "DIP26022064",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022064",
                    "resultValue": "2.5 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26004",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/02/1901",
                    "sampleDescription": "DIP26022069",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022069",
                    "resultValue": "0.05 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26004"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26004",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/02/1902",
                    "sampleDescription": "DIP26022070",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022070",
                    "resultValue": "0.06 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26004"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/02/1927",
                    "sampleDescription": "DIP26022093",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022093",
                    "resultValue": "5.3 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/02/1954",
                    "sampleDescription": "DIP26022120",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022120",
                    "resultValue": "6.1 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/02/1986",
                    "sampleDescription": "DIP26022145",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022145",
                    "resultValue": "5.1 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/02/2006",
                    "sampleDescription": "DIP26022169",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022169",
                    "resultValue": "4.7 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/02/2029",
                    "sampleDescription": "DIP26022198",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022198",
                    "resultValue": "4.4 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26005",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-B",
                    "sampleID": "D/IM/26/02/1987",
                    "sampleDescription": "DIP26022223",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022223",
                    "resultValue": "0.0004",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26005"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26005",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity of Stage-C.",
                    "sampleID": "D/IM/26/02/1987",
                    "sampleDescription": "DIP26022223",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022223",
                    "resultValue": "0.68",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26005"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/02/2053",
                    "sampleDescription": "DIP26022232",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022232",
                    "resultValue": "8.2 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/02/2099",
                    "sampleDescription": "DIP26022267",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022267",
                    "resultValue": "4.9 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26004",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity",
                    "sampleID": "D/IM/26/02/1989",
                    "sampleDescription": "DIP26022305",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022305",
                    "resultValue": "0.986",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26004"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26004",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of benzophenone hydrazine",
                    "sampleID": "D/IM/26/02/1989",
                    "sampleDescription": "DIP26022305",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022305",
                    "resultValue": "0.001",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26004"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26004",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-C dimer impurity",
                    "sampleID": "D/IM/26/02/1989",
                    "sampleDescription": "DIP26022305",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022305",
                    "resultValue": "Not Detected",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26004"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/02/2168",
                    "sampleDescription": "DIP26022347",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022347",
                    "resultValue": "4.5 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26006",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/02/2232",
                    "sampleDescription": "DIP26022409",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022409",
                    "resultValue": "0.06 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26006"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26006",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/02/2233",
                    "sampleDescription": "DIP26022410",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022410",
                    "resultValue": "0.06 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26006"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26006",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/02/2298",
                    "sampleDescription": "DIP26022473",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022473",
                    "resultValue": "0.09 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26006"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26004",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/02/2337",
                    "sampleDescription": "DIP26022511",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022511",
                    "resultValue": "1.9 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26004"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26004",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/02/2368",
                    "sampleDescription": "DIP26022547",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022547",
                    "resultValue": "0.87 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26004"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26006",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-B",
                    "sampleID": "D/IM/26/02/2333",
                    "sampleDescription": "DIP26022564",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022564",
                    "resultValue": "Not Detected",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26006"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26006",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity of Stage-C.",
                    "sampleID": "D/IM/26/02/2333",
                    "sampleDescription": "DIP26022564",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022564",
                    "resultValue": "0.698",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26006"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/02/2493",
                    "sampleDescription": "DIP26022673",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022673",
                    "resultValue": "0.06 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26007",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/02/2523",
                    "sampleDescription": "DIP26022700",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26022700",
                    "resultValue": "0.06 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26007"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26005",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity",
                    "sampleID": "D/IM/26/02/2466",
                    "sampleDescription": "DIP26030005",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030005",
                    "resultValue": "0.971",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26005"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26005",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of benzophenone hydrazine",
                    "sampleID": "D/IM/26/02/2466",
                    "sampleDescription": "DIP26030005",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030005",
                    "resultValue": "0.0033",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26005"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26005",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-C dimer impurity",
                    "sampleID": "D/IM/26/02/2466",
                    "sampleDescription": "DIP26030005",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030005",
                    "resultValue": "Not Detected",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26005"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/03/0081",
                    "sampleDescription": "DIP26030075",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030075",
                    "resultValue": "0.05 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26005",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/03/0158",
                    "sampleDescription": "DIP26030148",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030148",
                    "resultValue": "1.1 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26005"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-B",
                    "sampleID": "D/IM/26/03/0083",
                    "sampleDescription": "DIP26030177",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030177",
                    "resultValue": "0.0007",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity of Stage-C.",
                    "sampleID": "D/IM/26/03/0083",
                    "sampleDescription": "DIP26030177",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030177",
                    "resultValue": "0.461",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26007",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-B",
                    "sampleID": "D/IM/26/03/0176",
                    "sampleDescription": "DIP26030230",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030230",
                    "resultValue": "Not Detected",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26007"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26007",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity of Stage-C.",
                    "sampleID": "D/IM/26/03/0176",
                    "sampleDescription": "DIP26030230",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030230",
                    "resultValue": "0.747",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26007"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26006",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/03/0364",
                    "sampleDescription": "DIP26030346",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030346",
                    "resultValue": "0.06 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26006"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26007",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity",
                    "sampleID": "D/IM/26/03/0413",
                    "sampleDescription": "DIP26030531",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030531",
                    "resultValue": "0.963",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26007"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26007",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of benzophenone hydrazine",
                    "sampleID": "D/IM/26/03/0413",
                    "sampleDescription": "DIP26030531",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030531",
                    "resultValue": "0.0019",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26007"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26007",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-C dimer impurity",
                    "sampleID": "D/IM/26/03/0413",
                    "sampleDescription": "DIP26030531",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030531",
                    "resultValue": "Not Detected",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26007"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26006",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity",
                    "sampleID": "D/IM/26/03/0487",
                    "sampleDescription": "DIP26030543",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030543",
                    "resultValue": "0.972",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26006"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26006",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of benzophenone hydrazine",
                    "sampleID": "D/IM/26/03/0487",
                    "sampleDescription": "DIP26030543",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030543",
                    "resultValue": "Not Detected",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26006"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26006",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-C dimer impurity",
                    "sampleID": "D/IM/26/03/0487",
                    "sampleDescription": "DIP26030543",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030543",
                    "resultValue": "Not Detected",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26006"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26009",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/03/0599",
                    "sampleDescription": "DIP26030583",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030583",
                    "resultValue": "0.06 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26009"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26009",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/03/0600",
                    "sampleDescription": "DIP26030585",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030585",
                    "resultValue": "0.06 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26009"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26007",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/03/0656",
                    "sampleDescription": "DIP26030636",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030636",
                    "resultValue": "0.96 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26007"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26006",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/03/0681",
                    "sampleDescription": "DIP26030650",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030650",
                    "resultValue": "0.70 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26006"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/03/0706",
                    "sampleDescription": "DIP26030675",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030675",
                    "resultValue": "0.05 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/03/0707",
                    "sampleDescription": "DIP26030676",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030676",
                    "resultValue": "0.06 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26009",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-B",
                    "sampleID": "D/IM/26/03/0659",
                    "sampleDescription": "DIP26030681",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030681",
                    "resultValue": "Not Detected",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26009"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26009",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity of Stage-C.",
                    "sampleID": "D/IM/26/03/0659",
                    "sampleDescription": "DIP26030681",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030681",
                    "resultValue": "0.767",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26009"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26009",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/03/0774",
                    "sampleDescription": "DIP26030754",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030754",
                    "resultValue": "0.05 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26009"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity",
                    "sampleID": "D/IM/26/03/0703",
                    "sampleDescription": "DIP26030791",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030791",
                    "resultValue": "0.974",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of benzophenone hydrazine",
                    "sampleID": "D/IM/26/03/0703",
                    "sampleDescription": "DIP26030791",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030791",
                    "resultValue": "Not Detected",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-C dimer impurity",
                    "sampleID": "D/IM/26/03/0703",
                    "sampleDescription": "DIP26030791",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030791",
                    "resultValue": "Not Detected",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26010",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/03/0903",
                    "sampleDescription": "DIP26030870",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030870",
                    "resultValue": "0.06 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26010"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/03/1003",
                    "sampleDescription": "DIP26030963",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26030963",
                    "resultValue": "0.58 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26010",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-B",
                    "sampleID": "D/IM/26/03/1001",
                    "sampleDescription": "DIP26031033",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26031033",
                    "resultValue": "0.0017",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26010"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26010",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity of Stage-C.",
                    "sampleID": "D/IM/26/03/1001",
                    "sampleDescription": "DIP26031033",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26031033",
                    "resultValue": "0.62",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26010"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26011",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/03/1190",
                    "sampleDescription": "DIP26031148",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26031148",
                    "resultValue": "0.04 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26011"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26011",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/03/1191",
                    "sampleDescription": "DIP26031149",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26031149",
                    "resultValue": "0.05 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26011"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26009",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity",
                    "sampleID": "D/IM/26/03/1185",
                    "sampleDescription": "DIP26031211",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26031211",
                    "resultValue": "0.976",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26009"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26009",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of benzophenone hydrazine",
                    "sampleID": "D/IM/26/03/1185",
                    "sampleDescription": "DIP26031211",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26031211",
                    "resultValue": "Not Detected",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26009"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26009",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-C dimer impurity",
                    "sampleID": "D/IM/26/03/1185",
                    "sampleDescription": "DIP26031211",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26031211",
                    "resultValue": "0.0009",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26009"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26011",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-B",
                    "sampleID": "D/IM/26/03/1240",
                    "sampleDescription": "DIP26031233",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26031233",
                    "resultValue": "0.002",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26011"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26011",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity of Stage-C.",
                    "sampleID": "D/IM/26/03/1240",
                    "sampleDescription": "DIP26031233",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26031233",
                    "resultValue": "0.772",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26011"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26010",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/03/1327",
                    "sampleDescription": "DIP26031280",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26031280",
                    "resultValue": "0.04 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26010"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26010",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/03/1381",
                    "sampleDescription": "DIP26031330",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26031330",
                    "resultValue": "0.07 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26010"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26009",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/03/1421",
                    "sampleDescription": "DIP26031365",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26031365",
                    "resultValue": "0.49 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26009"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26012",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/03/1508",
                    "sampleDescription": "DIP26031460",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26031460",
                    "resultValue": "0.08 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26012"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26010",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity",
                    "sampleID": "D/IM/26/03/1428",
                    "sampleDescription": "DIP26031507",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26031507",
                    "resultValue": "0.981",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26010"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26010",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of benzophenone hydrazine",
                    "sampleID": "D/IM/26/03/1428",
                    "sampleDescription": "DIP26031507",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26031507",
                    "resultValue": "Not Detected",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26010"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26010",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-C dimer impurity",
                    "sampleID": "D/IM/26/03/1428",
                    "sampleDescription": "DIP26031507",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26031507",
                    "resultValue": "Not Detected",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26010"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26011",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/03/1647",
                    "sampleDescription": "DIP26031607",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26031607",
                    "resultValue": "0.04 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26011"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26012",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-B",
                    "sampleID": "D/IM/26/03/1532",
                    "sampleDescription": "DIP26031631",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26031631",
                    "resultValue": "0",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26012"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26012",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity of Stage-C.",
                    "sampleID": "D/IM/26/03/1532",
                    "sampleDescription": "DIP26031631",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26031631",
                    "resultValue": "0.773",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26012"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26010",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/03/1739",
                    "sampleDescription": "DIP26031696",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26031696",
                    "resultValue": "0.51 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26010"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26011",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity",
                    "sampleID": "D/IM/26/03/1747",
                    "sampleDescription": "DIP26031826",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26031826",
                    "resultValue": "0.981",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26011"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26011",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of benzophenone hydrazine",
                    "sampleID": "D/IM/26/03/1747",
                    "sampleDescription": "DIP26031826",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26031826",
                    "resultValue": "0.0006",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26011"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26011",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-C dimer impurity",
                    "sampleID": "D/IM/26/03/1747",
                    "sampleDescription": "DIP26031826",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26031826",
                    "resultValue": "0.0009",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26011"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Hydrazine in Stage-C filtrate mL’s by GC-HS (ppm)",
                    "sampleID": "D/IM/26/03/1964",
                    "sampleDescription": "DIP26031940",
                    "specificationLimit": "Not more than 200",
                    "analyticalReportNumber": "DIP26031940",
                    "resultValue": "2.4 ppm",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "ppm",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26012",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
                    "sampleID": "D/IM/26/03/2040",
                    "sampleDescription": "DIP26032009",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26032009",
                    "resultValue": "0.07 % w/v",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/v",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26012"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26011",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/03/2039",
                    "sampleDescription": "DIP26032081",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26032081",
                    "resultValue": "0.48 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26011"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26012",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Purity",
                    "sampleID": "D/IM/26/03/1942",
                    "sampleDescription": "DIP26032141",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26032141",
                    "resultValue": "0.977",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26012"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26012",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of benzophenone hydrazine",
                    "sampleID": "D/IM/26/03/1942",
                    "sampleDescription": "DIP26032141",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26032141",
                    "resultValue": "0.0006",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26012"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26012",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Content of Stage-C dimer impurity",
                    "sampleID": "D/IM/26/03/1942",
                    "sampleDescription": "DIP26032141",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26032141",
                    "resultValue": "0.0009",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "%",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26012"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26012",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IP-03/00",
                    "methodName": "Loss on drying of Stage-C (% w/w)",
                    "sampleID": "D/IM/26/03/2378",
                    "sampleDescription": "DIP26032361",
                    "specificationLimit": "Report the result",
                    "analyticalReportNumber": "DIP26032361",
                    "resultValue": "0.58 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "uom": "% w/w",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26012"
          }
],
        },
        {
          id: 3,
          name: 'Product Release Tests',
          hasFilters: false,
          columns: [
            { id: 1, name: 'Campaign / Batch', field: 'campaignBatch' },
            { id: 2, name: 'Method Number', field: 'methodNumber' },
            { id: 3, name: 'Method Name', field: 'methodName' },
            { id: 4, name: 'Sample ID', field: 'sampleID' },
            { id: 5, name: 'Specification Limit', field: 'specificationLimit' },
            { id: 6, name: 'AR Number', field: 'arNumber' },
            { id: 7, name: 'Result Value', field: 'resultValue' },
            { id: 8, name: 'Result', field: 'result' },
          ],
          rows: [
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Description",
                    "sampleID": "D/IM/26/01/0930",
                    "sampleDescription": "DIMCBSQ260001",
                    "specificationLimit": "Report the observation",
                    "arNumber": "DIMCBSQ260001",
                    "resultValue": "pale  brown color solid ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Identification by UPLC",
                    "sampleID": "D/IM/26/01/0930",
                    "sampleDescription": "DIMCBSQ260001",
                    "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
                    "arNumber": "DIMCBSQ260001",
                    "resultValue": "Complies ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Loss on drying (% w/w)",
                    "sampleID": "D/IM/26/01/0930",
                    "sampleDescription": "DIMCBSQ260001",
                    "specificationLimit": "Not more than 2.0",
                    "arNumber": "DIMCBSQ260001",
                    "resultValue": "0.6",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Chromatographic purity by UPLC (% area)",
                    "sampleID": "D/IM/26/01/0930",
                    "sampleDescription": "DIMCBSQ260001",
                    "specificationLimit": "Not less than 90.0",
                    "arNumber": "DIMCBSQ260001",
                    "resultValue": "0.974",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Assay by UPLC (% w/w, as is basis)",
                    "sampleID": "D/IM/26/01/0930",
                    "sampleDescription": "DIMCBSQ260001",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260001",
                    "resultValue": "93.8 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Assay by UPLC (% w/w)(on dried basis)",
                    "sampleID": "D/IM/26/01/0930",
                    "sampleDescription": "DIMCBSQ260001",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260001",
                    "resultValue": "94.4 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Description",
                    "sampleID": "D/IM/26/02/1354",
                    "sampleDescription": "DIMCBSQ260002",
                    "specificationLimit": "Report the observation",
                    "arNumber": "DIMCBSQ260002",
                    "resultValue": "Pale brown color solid ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Identification by UPLC",
                    "sampleID": "D/IM/26/02/1354",
                    "sampleDescription": "DIMCBSQ260002",
                    "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
                    "arNumber": "DIMCBSQ260002",
                    "resultValue": "Complies ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Loss on drying (% w/w)",
                    "sampleID": "D/IM/26/02/1354",
                    "sampleDescription": "DIMCBSQ260002",
                    "specificationLimit": "Not more than 2.0",
                    "arNumber": "DIMCBSQ260002",
                    "resultValue": "3.2 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Chromatographic purity by UPLC (% area)",
                    "sampleID": "D/IM/26/02/1354",
                    "sampleDescription": "DIMCBSQ260002",
                    "specificationLimit": "Not less than 90.0",
                    "arNumber": "DIMCBSQ260002",
                    "resultValue": "0.959",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Assay by UPLC (% w/w, as is basis)",
                    "sampleID": "D/IM/26/02/1354",
                    "sampleDescription": "DIMCBSQ260002",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260002",
                    "resultValue": "89.3 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Assay by UPLC (% w/w)(on dried basis)",
                    "sampleID": "D/IM/26/02/1354",
                    "sampleDescription": "DIMCBSQ260002",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260002",
                    "resultValue": "92.3 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Use test",
                    "sampleID": "D/IM/26/02/1354",
                    "sampleDescription": "DIMCBSQ260002",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260002",
                    "resultValue": "Complies ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26004",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Description",
                    "sampleID": "D/IM/26/02/2455",
                    "sampleDescription": "DIMCBSQ260003",
                    "specificationLimit": "Report the observation",
                    "arNumber": "DIMCBSQ260003",
                    "resultValue": "pale yellow color solid ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26004"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26004",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Identification by UPLC",
                    "sampleID": "D/IM/26/02/2455",
                    "sampleDescription": "DIMCBSQ260003",
                    "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
                    "arNumber": "DIMCBSQ260003",
                    "resultValue": "Complies ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26004"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26004",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Loss on drying (% w/w)",
                    "sampleID": "D/IM/26/02/2455",
                    "sampleDescription": "DIMCBSQ260003",
                    "specificationLimit": "Not more than 2.0",
                    "arNumber": "DIMCBSQ260003",
                    "resultValue": "0.27 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26004"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26004",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Chromatographic purity by UPLC (% area)",
                    "sampleID": "D/IM/26/02/2455",
                    "sampleDescription": "DIMCBSQ260003",
                    "specificationLimit": "Not less than 90.0",
                    "arNumber": "DIMCBSQ260003",
                    "resultValue": "0.98",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26004"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26004",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Assay by UPLC (% w/w, as is basis)",
                    "sampleID": "D/IM/26/02/2455",
                    "sampleDescription": "DIMCBSQ260003",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260003",
                    "resultValue": "94.6 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26004"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26004",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Assay by UPLC (% w/w)(on dried basis)",
                    "sampleID": "D/IM/26/02/2455",
                    "sampleDescription": "DIMCBSQ260003",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260003",
                    "resultValue": "94.9 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26004"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Description",
                    "sampleID": "D/IM/26/02/2497",
                    "sampleDescription": "DIMCBSQ260004",
                    "specificationLimit": "Report the observation",
                    "arNumber": "DIMCBSQ260004",
                    "resultValue": "Pale yellow color solid ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Identification by UPLC",
                    "sampleID": "D/IM/26/02/2497",
                    "sampleDescription": "DIMCBSQ260004",
                    "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
                    "arNumber": "DIMCBSQ260004",
                    "resultValue": "Complies ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Loss on drying (% w/w)",
                    "sampleID": "D/IM/26/02/2497",
                    "sampleDescription": "DIMCBSQ260004",
                    "specificationLimit": "Not more than 2.0",
                    "arNumber": "DIMCBSQ260004",
                    "resultValue": "3.9 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Chromatographic purity by UPLC (% area)",
                    "sampleID": "D/IM/26/02/2497",
                    "sampleDescription": "DIMCBSQ260004",
                    "specificationLimit": "Not less than 90.0",
                    "arNumber": "DIMCBSQ260004",
                    "resultValue": "0.962",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Assay by UPLC (% w/w, as is basis)",
                    "sampleID": "D/IM/26/02/2497",
                    "sampleDescription": "DIMCBSQ260004",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260004",
                    "resultValue": "94.7 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Assay by UPLC (% w/w)(on dried basis)",
                    "sampleID": "D/IM/26/02/2497",
                    "sampleDescription": "DIMCBSQ260004",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260004",
                    "resultValue": "98.5 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Use test",
                    "sampleID": "D/IM/26/02/2497",
                    "sampleDescription": "DIMCBSQ260004",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260004",
                    "resultValue": "Complies ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26005",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Description",
                    "sampleID": "D/IM/26/03/0240",
                    "sampleDescription": "DIMCBSQ260005",
                    "specificationLimit": "Report the observation",
                    "arNumber": "DIMCBSQ260005",
                    "resultValue": "pale yellow color solid ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26005"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26005",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Identification by UPLC",
                    "sampleID": "D/IM/26/03/0240",
                    "sampleDescription": "DIMCBSQ260005",
                    "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
                    "arNumber": "DIMCBSQ260005",
                    "resultValue": "Complies ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26005"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26005",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Loss on drying (% w/w)",
                    "sampleID": "D/IM/26/03/0240",
                    "sampleDescription": "DIMCBSQ260005",
                    "specificationLimit": "Not more than 2.0",
                    "arNumber": "DIMCBSQ260005",
                    "resultValue": "1.0 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26005"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26005",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Chromatographic purity by UPLC (% area)",
                    "sampleID": "D/IM/26/03/0240",
                    "sampleDescription": "DIMCBSQ260005",
                    "specificationLimit": "Not less than 90.0",
                    "arNumber": "DIMCBSQ260005",
                    "resultValue": "0.978",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26005"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26005",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Assay by UPLC (% w/w, as is basis)",
                    "sampleID": "D/IM/26/03/0240",
                    "sampleDescription": "DIMCBSQ260005",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260005",
                    "resultValue": "93.1 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26005"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26005",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Assay by UPLC (% w/w)(on dried basis)",
                    "sampleID": "D/IM/26/03/0240",
                    "sampleDescription": "DIMCBSQ260005",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260005",
                    "resultValue": "94.1 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26005"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26007",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Description",
                    "sampleID": "D/IM/26/03/0726",
                    "sampleDescription": "DIMCBSQ260006",
                    "specificationLimit": "Report the observation",
                    "arNumber": "DIMCBSQ260006",
                    "resultValue": "Pale yellow color solid ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26007"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26007",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Identification by UPLC",
                    "sampleID": "D/IM/26/03/0726",
                    "sampleDescription": "DIMCBSQ260006",
                    "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
                    "arNumber": "DIMCBSQ260006",
                    "resultValue": "Complies ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26007"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26007",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Loss on drying (% w/w)",
                    "sampleID": "D/IM/26/03/0726",
                    "sampleDescription": "DIMCBSQ260006",
                    "specificationLimit": "Not more than 2.0",
                    "arNumber": "DIMCBSQ260006",
                    "resultValue": "0.90 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26007"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26007",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Chromatographic purity by UPLC (% area)",
                    "sampleID": "D/IM/26/03/0726",
                    "sampleDescription": "DIMCBSQ260006",
                    "specificationLimit": "Not less than 90.0",
                    "arNumber": "DIMCBSQ260006",
                    "resultValue": "96.8",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26007"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26007",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Assay by UPLC (% w/w, as is basis)",
                    "sampleID": "D/IM/26/03/0726",
                    "sampleDescription": "DIMCBSQ260006",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260006",
                    "resultValue": "90.3 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26007"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26007",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Assay by UPLC (% w/w)(on dried basis)",
                    "sampleID": "D/IM/26/03/0726",
                    "sampleDescription": "DIMCBSQ260006",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260006",
                    "resultValue": "91.1 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26007"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26006",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Description",
                    "sampleID": "D/IM/26/03/0790",
                    "sampleDescription": "DIMCBSQ260007",
                    "specificationLimit": "Report the observation",
                    "arNumber": "DIMCBSQ260007",
                    "resultValue": "Pale yellow color solid ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26006"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26006",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Identification by UPLC",
                    "sampleID": "D/IM/26/03/0790",
                    "sampleDescription": "DIMCBSQ260007",
                    "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
                    "arNumber": "DIMCBSQ260007",
                    "resultValue": "Complies ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26006"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26006",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Loss on drying (% w/w)",
                    "sampleID": "D/IM/26/03/0790",
                    "sampleDescription": "DIMCBSQ260007",
                    "specificationLimit": "Not more than 2.0",
                    "arNumber": "DIMCBSQ260007",
                    "resultValue": "0.66 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26006"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26006",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Chromatographic purity by UPLC (% area)",
                    "sampleID": "D/IM/26/03/0790",
                    "sampleDescription": "DIMCBSQ260007",
                    "specificationLimit": "Not less than 90.0",
                    "arNumber": "DIMCBSQ260007",
                    "resultValue": "0.965",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26006"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26006",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Assay by UPLC (% w/w, as is basis)",
                    "sampleID": "D/IM/26/03/0790",
                    "sampleDescription": "DIMCBSQ260007",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260007",
                    "resultValue": "91.0 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26006"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26006",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Assay by UPLC (% w/w)(on dried basis)",
                    "sampleID": "D/IM/26/03/0790",
                    "sampleDescription": "DIMCBSQ260007",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260007",
                    "resultValue": "91.6 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26006"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Description",
                    "sampleID": "D/IM/26/03/1149",
                    "sampleDescription": "DIMCBSQ260008",
                    "specificationLimit": "Report the observation",
                    "arNumber": "DIMCBSQ260008",
                    "resultValue": "Pale yellow color solid ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Identification by UPLC",
                    "sampleID": "D/IM/26/03/1149",
                    "sampleDescription": "DIMCBSQ260008",
                    "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
                    "arNumber": "DIMCBSQ260008",
                    "resultValue": "Complies ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Loss on drying (% w/w)",
                    "sampleID": "D/IM/26/03/1149",
                    "sampleDescription": "DIMCBSQ260008",
                    "specificationLimit": "Not more than 2.0",
                    "arNumber": "DIMCBSQ260008",
                    "resultValue": "0.21 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Chromatographic purity by UPLC (% area)",
                    "sampleID": "D/IM/26/03/1149",
                    "sampleDescription": "DIMCBSQ260008",
                    "specificationLimit": "Not less than 90.0",
                    "arNumber": "DIMCBSQ260008",
                    "resultValue": "97.7",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Assay by UPLC (% w/w, as is basis)",
                    "sampleID": "D/IM/26/03/1149",
                    "sampleDescription": "DIMCBSQ260008",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260008",
                    "resultValue": "94.3 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Assay by UPLC (% w/w)(on dried basis)",
                    "sampleID": "D/IM/26/03/1149",
                    "sampleDescription": "DIMCBSQ260008",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260008",
                    "resultValue": "94.5 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26009",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Description",
                    "sampleID": "D/IM/26/03/1577",
                    "sampleDescription": "DIMCBSQ260009",
                    "specificationLimit": "Report the observation",
                    "arNumber": "DIMCBSQ260009",
                    "resultValue": "Pale yellow color solid ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26009"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26009",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Identification by UPLC",
                    "sampleID": "D/IM/26/03/1577",
                    "sampleDescription": "DIMCBSQ260009",
                    "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
                    "arNumber": "DIMCBSQ260009",
                    "resultValue": "Complies ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26009"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26009",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Loss on drying (% w/w)",
                    "sampleID": "D/IM/26/03/1577",
                    "sampleDescription": "DIMCBSQ260009",
                    "specificationLimit": "Not more than 2.0",
                    "arNumber": "DIMCBSQ260009",
                    "resultValue": "0.65 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26009"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26009",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Chromatographic purity by UPLC (% area)",
                    "sampleID": "D/IM/26/03/1577",
                    "sampleDescription": "DIMCBSQ260009",
                    "specificationLimit": "Not less than 90.0",
                    "arNumber": "DIMCBSQ260009",
                    "resultValue": "0.98",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26009"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26009",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Assay by UPLC (% w/w, as is basis)",
                    "sampleID": "D/IM/26/03/1577",
                    "sampleDescription": "DIMCBSQ260009",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260009",
                    "resultValue": "95.1 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26009"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26009",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Assay by UPLC (% w/w)(on dried basis)",
                    "sampleID": "D/IM/26/03/1577",
                    "sampleDescription": "DIMCBSQ260009",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260009",
                    "resultValue": "95.8 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26009"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26010",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Description",
                    "sampleID": "D/IM/26/03/1875",
                    "sampleDescription": "DIMCBSQ260010",
                    "specificationLimit": "Report the observation",
                    "arNumber": "DIMCBSQ260010",
                    "resultValue": "Pale yellow color solid ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26010"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26010",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Identification by UPLC",
                    "sampleID": "D/IM/26/03/1875",
                    "sampleDescription": "DIMCBSQ260010",
                    "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
                    "arNumber": "DIMCBSQ260010",
                    "resultValue": "Complies ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26010"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26010",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Loss on drying (% w/w)",
                    "sampleID": "D/IM/26/03/1875",
                    "sampleDescription": "DIMCBSQ260010",
                    "specificationLimit": "Not more than 2.0",
                    "arNumber": "DIMCBSQ260010",
                    "resultValue": "2.3 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26010"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26010",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Chromatographic purity by UPLC (% area)",
                    "sampleID": "D/IM/26/03/1875",
                    "sampleDescription": "DIMCBSQ260010",
                    "specificationLimit": "Not less than 90.0",
                    "arNumber": "DIMCBSQ260010",
                    "resultValue": "0.985",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26010"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26010",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Assay by UPLC (% w/w, as is basis)",
                    "sampleID": "D/IM/26/03/1875",
                    "sampleDescription": "DIMCBSQ260010",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260010",
                    "resultValue": "91.8 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26010"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26010",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Assay by UPLC (% w/w)(on dried basis)",
                    "sampleID": "D/IM/26/03/1875",
                    "sampleDescription": "DIMCBSQ260010",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260010",
                    "resultValue": "94.0 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26010"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26010",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Use test",
                    "sampleID": "D/IM/26/03/1875",
                    "sampleDescription": "DIMCBSQ260010",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260010",
                    "resultValue": "Complies ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26010"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26011",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Description",
                    "sampleID": "D/IM/26/03/2235",
                    "sampleDescription": "DIMCBSQ260011",
                    "specificationLimit": "Report the observation",
                    "arNumber": "DIMCBSQ260011",
                    "resultValue": "Pale yellow color solid ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26011"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26011",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Identification by UPLC",
                    "sampleID": "D/IM/26/03/2235",
                    "sampleDescription": "DIMCBSQ260011",
                    "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
                    "arNumber": "DIMCBSQ260011",
                    "resultValue": "Complies ",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26011"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26011",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Loss on drying (% w/w)",
                    "sampleID": "D/IM/26/03/2235",
                    "sampleDescription": "DIMCBSQ260011",
                    "specificationLimit": "Not more than 2.0",
                    "arNumber": "DIMCBSQ260011",
                    "resultValue": "0.23 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26011"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26011",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Chromatographic purity by UPLC (% area)",
                    "sampleID": "D/IM/26/03/2235",
                    "sampleDescription": "DIMCBSQ260011",
                    "specificationLimit": "Not less than 90.0",
                    "arNumber": "DIMCBSQ260011",
                    "resultValue": "0.975",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26011"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26011",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Assay by UPLC (% w/w, as is basis)",
                    "sampleID": "D/IM/26/03/2235",
                    "sampleDescription": "DIMCBSQ260011",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260011",
                    "resultValue": "95.1 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26011"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26011",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "Assay by UPLC (% w/w)(on dried basis)",
                    "sampleID": "D/IM/26/03/2235",
                    "sampleDescription": "DIMCBSQ260011",
                    "specificationLimit": "Report the result",
                    "arNumber": "DIMCBSQ260011",
                    "resultValue": "95.3 % w/w",
                    "result": "Pass",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26011"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26012",
                    "procedureNumber": "",
                    "methodNumber": "BSQ-IN-03/00",
                    "methodName": "",
                    "sampleID": "D/IM/26/03/2467",
                    "sampleDescription": "DIMCBSQ260012",
                    "specificationLimit": "",
                    "arNumber": "DIMCBSQ260012",
                    "resultValue": "",
                    "result": "N/A",
                    "cqas": "",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26012"
          }
],
        },
        {
          id: 4,
          name: 'Equipment',
          hasFilters: false,
          columns: [
            { id: 1, name: 'Campaign / Batch', field: 'campaignBatch' },
            { id: 2, name: 'Equipment', field: 'equipment' },
            { id: 3, name: 'Location', field: 'location' },
            { id: 4, name: 'Equipment Type', field: 'equipmentType' },
            { id: 5, name: 'Equipment Title', field: 'equipmentTitle' },
          ],
          rows: [
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "equipment": "DSSR84",
                    "location": "Production Block - 11",
                    "equipmentType": "REACTOR",
                    "equipmentTitle": "SS REACTOR",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "equipment": "DGLB37",
                    "location": "Production Block - 11",
                    "equipmentType": "GLOVE BOX",
                    "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "equipment": "DNFD25-1",
                    "location": "Production Block - 11",
                    "equipmentType": "DRYER",
                    "equipmentTitle": "AGITATED NUTSCHE FILTER DRYER",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "equipment": "DSNF41",
                    "location": "Production Block - 07",
                    "equipmentType": "FILTER",
                    "equipmentTitle": "SS (ROBO) NUTSCHE FILTER",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "equipment": "DNFD25-1",
                    "location": "Production Block - 11",
                    "equipmentType": "DRYER",
                    "equipmentTitle": "AGITATED NUTSCHE FILTER DRYER",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "equipment": "DSSR81",
                    "location": "Production Block - 11",
                    "equipmentType": "REACTOR",
                    "equipmentTitle": "SS REACTOR",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC25001",
                    "equipment": "DGLB32",
                    "location": "Production Block - 08",
                    "equipmentType": "GLOVE BOX",
                    "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC25001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "equipment": "DSSR81",
                    "location": "Production Block - 11",
                    "equipmentType": "REACTOR",
                    "equipmentTitle": "SS REACTOR",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "equipment": "DGLB32",
                    "location": "Production Block - 08",
                    "equipmentType": "GLOVE BOX",
                    "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26001",
                    "equipment": "DNFD45",
                    "location": "Production Block - 11",
                    "equipmentType": "DRYER",
                    "equipmentTitle": "AGITATED NUTSCHE FILTER DRYER",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26001"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "equipment": "DSSR81",
                    "location": "Production Block - 11",
                    "equipmentType": "REACTOR",
                    "equipmentTitle": "SS REACTOR",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "equipment": "DGLB32",
                    "location": "Production Block - 08",
                    "equipmentType": "GLOVE BOX",
                    "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26003",
                    "equipment": "DNFD45",
                    "location": "Production Block - 11",
                    "equipmentType": "DRYER",
                    "equipmentTitle": "AGITATED NUTSCHE FILTER DRYER",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26003"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26004",
                    "equipment": "DGLR64",
                    "location": "Production Block - 07",
                    "equipmentType": "REACTOR",
                    "equipmentTitle": "GL REACTOR",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26004"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26004",
                    "equipment": "DGLB29",
                    "location": "Production Block - 07",
                    "equipmentType": "GLOVE BOX",
                    "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26004"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26004",
                    "equipment": "DSCF15",
                    "location": "Production Block - 07",
                    "equipmentType": "CENTRIFUGE",
                    "equipmentTitle": "SS PVDF LINED CENTRIFUGE",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26004"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26004",
                    "equipment": "DGLB04-1",
                    "location": "Production Block - 07",
                    "equipmentType": "GLOVE BOX",
                    "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26004"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26004",
                    "equipment": "DRVD08",
                    "location": "Production Block - 07",
                    "equipmentType": "DRYER",
                    "equipmentTitle": "SS ROTOCONE VACUUM DRYER",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26004"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26005",
                    "equipment": "DSSR81",
                    "location": "Production Block - 11",
                    "equipmentType": "REACTOR",
                    "equipmentTitle": "SS REACTOR",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26005"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26005",
                    "equipment": "DGLB32",
                    "location": "Production Block - 08",
                    "equipmentType": "GLOVE BOX",
                    "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26005"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26005",
                    "equipment": "DNFD45",
                    "location": "Production Block - 11",
                    "equipmentType": "DRYER",
                    "equipmentTitle": "AGITATED NUTSCHE FILTER DRYER",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26005"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26006",
                    "equipment": "DGLR64",
                    "location": "Production Block - 07",
                    "equipmentType": "REACTOR",
                    "equipmentTitle": "GL REACTOR",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26006"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26006",
                    "equipment": "DGLB04-1",
                    "location": "Production Block - 07",
                    "equipmentType": "GLOVE BOX",
                    "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26006"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26006",
                    "equipment": "DSCF15",
                    "location": "Production Block - 07",
                    "equipmentType": "CENTRIFUGE",
                    "equipmentTitle": "SS PVDF LINED CENTRIFUGE",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26006"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26006",
                    "equipment": "DGLR64",
                    "location": "Production Block - 07",
                    "equipmentType": "REACTOR",
                    "equipmentTitle": "GL REACTOR",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26006"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26006",
                    "equipment": "DGLB04-1",
                    "location": "Production Block - 07",
                    "equipmentType": "GLOVE BOX",
                    "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26006"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26006",
                    "equipment": "DRVD08",
                    "location": "Production Block - 07",
                    "equipmentType": "DRYER",
                    "equipmentTitle": "SS ROTOCONE VACUUM DRYER",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26006"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26007",
                    "equipment": "DSSR81",
                    "location": "Production Block - 11",
                    "equipmentType": "REACTOR",
                    "equipmentTitle": "SS REACTOR",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26007"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26007",
                    "equipment": "DGLB32",
                    "location": "Production Block - 08",
                    "equipmentType": "GLOVE BOX",
                    "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26007"
          },
          {
                    "campaignBatch": "CMPO04TEV169 / DBSQC26007",
                    "equipment": "DNFD45",
                    "location": "Production Block - 11",
                    "equipmentType": "DRYER",
                    "equipmentTitle": "AGITATED NUTSCHE FILTER DRYER",
                    "campaignId": "CMPO04TEV169",
                    "batchId": "DBSQC26007"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "equipment": "DSSR57",
                    "location": "Production Block - 08",
                    "equipmentType": "REACTOR",
                    "equipmentTitle": "SS REACTOR",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "equipment": "DGLB05",
                    "location": "Production Block - 07",
                    "equipmentType": "GLOVE BOX",
                    "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "equipment": "DSCF23",
                    "location": "Production Block - 08",
                    "equipmentType": "CENTRIFUGE",
                    "equipmentTitle": "CENTRIFUGE",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "equipment": "DSCF18",
                    "location": "Production Block - 08",
                    "equipmentType": "CENTRIFUGE",
                    "equipmentTitle": "CENTRIFUGE",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "equipment": "DGLB05",
                    "location": "Production Block - 07",
                    "equipmentType": "GLOVE BOX",
                    "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26008",
                    "equipment": "DRVD08",
                    "location": "Production Block - 07",
                    "equipmentType": "DRYER",
                    "equipmentTitle": "SS ROTOCONE VACUUM DRYER",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26008"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26009",
                    "equipment": "DGLR64",
                    "location": "Production Block - 07",
                    "equipmentType": "REACTOR",
                    "equipmentTitle": "GL REACTOR",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26009"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26009",
                    "equipment": "DGLB04-1",
                    "location": "Production Block - 07",
                    "equipmentType": "GLOVE BOX",
                    "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26009"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26009",
                    "equipment": "DSCF15",
                    "location": "Production Block - 07",
                    "equipmentType": "CENTRIFUGE",
                    "equipmentTitle": "SS PVDF LINED CENTRIFUGE",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26009"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26009",
                    "equipment": "DGLB04-1",
                    "location": "Production Block - 07",
                    "equipmentType": "GLOVE BOX",
                    "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26009"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26009",
                    "equipment": "DRVD08",
                    "location": "Production Block - 07",
                    "equipmentType": "DRYER",
                    "equipmentTitle": "SS ROTOCONE VACUUM DRYER",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26009"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26010",
                    "equipment": "DSSR57",
                    "location": "Production Block - 08",
                    "equipmentType": "REACTOR",
                    "equipmentTitle": "SS REACTOR",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26010"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26010",
                    "equipment": "DGLB05",
                    "location": "Production Block - 07",
                    "equipmentType": "GLOVE BOX",
                    "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26010"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26010",
                    "equipment": "DSCF23",
                    "location": "Production Block - 08",
                    "equipmentType": "CENTRIFUGE",
                    "equipmentTitle": "CENTRIFUGE",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26010"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26010",
                    "equipment": "DSCF18",
                    "location": "Production Block - 08",
                    "equipmentType": "CENTRIFUGE",
                    "equipmentTitle": "CENTRIFUGE",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26010"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26010",
                    "equipment": "DRVD08",
                    "location": "Production Block - 07",
                    "equipmentType": "DRYER",
                    "equipmentTitle": "SS ROTOCONE VACUUM DRYER",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26010"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26011",
                    "equipment": "DGLR64",
                    "location": "Production Block - 07",
                    "equipmentType": "REACTOR",
                    "equipmentTitle": "GL REACTOR",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26011"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26011",
                    "equipment": "DGLB04-1",
                    "location": "Production Block - 07",
                    "equipmentType": "GLOVE BOX",
                    "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26011"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26011",
                    "equipment": "DSCF15",
                    "location": "Production Block - 07",
                    "equipmentType": "CENTRIFUGE",
                    "equipmentTitle": "SS PVDF LINED CENTRIFUGE",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26011"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26011",
                    "equipment": "DGLB04-1",
                    "location": "Production Block - 07",
                    "equipmentType": "GLOVE BOX",
                    "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26011"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26011",
                    "equipment": "DRVD08",
                    "location": "Production Block - 07",
                    "equipmentType": "DRYER",
                    "equipmentTitle": "SS ROTOCONE VACUUM DRYER",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26011"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26012",
                    "equipment": "DSSR57",
                    "location": "Production Block - 08",
                    "equipmentType": "REACTOR",
                    "equipmentTitle": "SS REACTOR",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26012"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26012",
                    "equipment": "DGLB05",
                    "location": "Production Block - 07",
                    "equipmentType": "GLOVE BOX",
                    "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26012"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26012",
                    "equipment": "DSCF23",
                    "location": "Production Block - 08",
                    "equipmentType": "CENTRIFUGE",
                    "equipmentTitle": "CENTRIFUGE",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26012"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26012",
                    "equipment": "DSCF18",
                    "location": "Production Block - 08",
                    "equipmentType": "CENTRIFUGE",
                    "equipmentTitle": "CENTRIFUGE",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26012"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26012",
                    "equipment": "DGLB05",
                    "location": "Production Block - 07",
                    "equipmentType": "GLOVE BOX",
                    "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26012"
          },
          {
                    "campaignBatch": "CMPO04BRS729 / DBSQC26012",
                    "equipment": "DRVD08",
                    "location": "Production Block - 07",
                    "equipmentType": "DRYER",
                    "equipmentTitle": "SS ROTOCONE VACUUM DRYER",
                    "campaignId": "CMPO04BRS729",
                    "batchId": "DBSQC26012"
          }
],
        },
      ],
      pageNumber: 1,
      pageSize: 20,
      totalPages: 1,
      totalRecords: 266,
    },
  };
};

// ===== ANALYTICS DATA API =====

const allTabData = {
  1: [
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "actualProductQuantity": "81.1",
        "expectedProductQuantity": "170",
        "uom": "Kg",
        "yield": "47.71%",
        "batchManufacturingDate": "16-JAN-2026",
        "expiryDate": "",
        "storageCondition": "",
        "storageLocation": "Unit-IV",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "actualProductQuantity": "233.46",
        "expectedProductQuantity": "390",
        "uom": "Kg",
        "yield": "59.86%",
        "batchManufacturingDate": "16-FEB-2026",
        "expiryDate": "",
        "storageCondition": "",
        "storageLocation": "Unit-IV",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26002",
        "actualProductQuantity": "0",
        "expectedProductQuantity": "390",
        "uom": "Kg",
        "yield": "",
        "batchManufacturingDate": "",
        "expiryDate": "",
        "storageCondition": "",
        "storageLocation": "Unit-IV",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26002"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "actualProductQuantity": "57.36",
        "expectedProductQuantity": "100",
        "uom": "Kg",
        "yield": "57.36%",
        "batchManufacturingDate": "28-FEB-2026",
        "expiryDate": "",
        "storageCondition": "",
        "storageLocation": "Unit-IV",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26004",
        "actualProductQuantity": "110.48",
        "expectedProductQuantity": "200",
        "uom": "Kg",
        "yield": "55.24%",
        "batchManufacturingDate": "28-FEB-2026",
        "expiryDate": "",
        "storageCondition": "",
        "storageLocation": "Unit-IV",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26004"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26005",
        "actualProductQuantity": "60.76",
        "expectedProductQuantity": "100",
        "uom": "Kg",
        "yield": "60.76%",
        "batchManufacturingDate": "02-MAR-2026",
        "expiryDate": "",
        "storageCondition": "",
        "storageLocation": "Unit-IV",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26005"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26006",
        "actualProductQuantity": "110.6",
        "expectedProductQuantity": "200",
        "uom": "Kg",
        "yield": "55.30%",
        "batchManufacturingDate": "08-MAR-2026",
        "expiryDate": "",
        "storageCondition": "",
        "storageLocation": "Unit-IV",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26006"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26007",
        "actualProductQuantity": "55.08",
        "expectedProductQuantity": "100",
        "uom": "Kg",
        "yield": "55.08%",
        "batchManufacturingDate": "08-MAR-2026",
        "expiryDate": "",
        "storageCondition": "",
        "storageLocation": "Unit-IV",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26007"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "actualProductQuantity": "190.02",
        "expectedProductQuantity": "360",
        "uom": "Kg",
        "yield": "52.78%",
        "batchManufacturingDate": "12-MAR-2026",
        "expiryDate": "",
        "storageCondition": "",
        "storageLocation": "Unit-IV",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26009",
        "actualProductQuantity": "120.44",
        "expectedProductQuantity": "220",
        "uom": "Kg",
        "yield": "54.75%",
        "batchManufacturingDate": "17-MAR-2026",
        "expiryDate": "",
        "storageCondition": "",
        "storageLocation": "Unit-IV",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26009"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26010",
        "actualProductQuantity": "205.7",
        "expectedProductQuantity": "380",
        "uom": "Kg",
        "yield": "54.13%",
        "batchManufacturingDate": "20-MAR-2026",
        "expiryDate": "",
        "storageCondition": "",
        "storageLocation": "Unit-IV",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26010"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26011",
        "actualProductQuantity": "128.02",
        "expectedProductQuantity": "220",
        "uom": "Kg",
        "yield": "58.19%",
        "batchManufacturingDate": "24-MAR-2026",
        "expiryDate": "",
        "storageCondition": "",
        "storageLocation": "Unit-IV",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26011"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26012",
        "actualProductQuantity": "112.54",
        "expectedProductQuantity": "205",
        "uom": "Kg",
        "yield": "54.90%",
        "batchManufacturingDate": "26-MAR-2026",
        "expiryDate": "",
        "storageCondition": "",
        "storageLocation": "Unit-IV",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26012"
    }
],
  2: [
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-B",
        "sampleID": "D/IM/25/12/0957",
        "sampleDescription": "DIP25121105",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP25121105",
        "resultValue": "0.0004",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity of Stage-C.",
        "sampleID": "D/IM/25/12/0957",
        "sampleDescription": "DIP25121105",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP25121105",
        "resultValue": "0.744",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/01/0190",
        "sampleDescription": "DIP26010222",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26010222",
        "resultValue": "0.05 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity",
        "sampleID": "D/IM/26/01/0337",
        "sampleDescription": "DIP26010484",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26010484",
        "resultValue": "0.943",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of benzophenone hydrazine",
        "sampleID": "D/IM/26/01/0337",
        "sampleDescription": "DIP26010484",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26010484",
        "resultValue": "0.037",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-C dimer impurity",
        "sampleID": "D/IM/26/01/0337",
        "sampleDescription": "DIP26010484",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26010484",
        "resultValue": "0.0017",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity",
        "sampleID": "D/IM/26/01/0765",
        "sampleDescription": "DIP26010843",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26010843",
        "resultValue": "0.968",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of benzophenone hydrazine",
        "sampleID": "D/IM/26/01/0765",
        "sampleDescription": "DIP26010843",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26010843",
        "resultValue": "0.0071",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-C dimer impurity",
        "sampleID": "D/IM/26/01/0765",
        "sampleDescription": "DIP26010843",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26010843",
        "resultValue": "0.0017",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/01/0836",
        "sampleDescription": "DIP26010925",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26010925",
        "resultValue": "1.7 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/01/0870",
        "sampleDescription": "DIP26010951",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26010951",
        "resultValue": "0.45 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/01/1266",
        "sampleDescription": "DIP26011409",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26011409",
        "resultValue": "0.06 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Hydrazine in Stage-C filtrate mL’s by GC-HS (ppm)",
        "sampleID": "D/IM/26/01/1357",
        "sampleDescription": "DIP26011507",
        "specificationLimit": "Not more than 200",
        "analyticalReportNumber": "DIP26011507",
        "resultValue": "2.5 ppm",
        "result": "Pass",
        "cqas": "",
        "uom": "ppm",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-B",
        "sampleID": "D/IM/26/01/1361",
        "sampleDescription": "DIP26011511",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26011511",
        "resultValue": "0.0006",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity of Stage-C.",
        "sampleID": "D/IM/26/01/1361",
        "sampleDescription": "DIP26011511",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26011511",
        "resultValue": "0.726",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity",
        "sampleID": "D/IM/26/02/0124",
        "sampleDescription": "DIP26020174",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26020174",
        "resultValue": "0.891",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of benzophenone hydrazine",
        "sampleID": "D/IM/26/02/0124",
        "sampleDescription": "DIP26020174",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26020174",
        "resultValue": "0.072",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-C dimer impurity",
        "sampleID": "D/IM/26/02/0124",
        "sampleDescription": "DIP26020174",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26020174",
        "resultValue": "Not Detected",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity",
        "sampleID": "D/IM/26/02/0605",
        "sampleDescription": "DIP26020687",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26020687",
        "resultValue": "0.965",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of benzophenone hydrazine",
        "sampleID": "D/IM/26/02/0605",
        "sampleDescription": "DIP26020687",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26020687",
        "resultValue": "0.006",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-C dimer impurity",
        "sampleID": "D/IM/26/02/0605",
        "sampleDescription": "DIP26020687",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26020687",
        "resultValue": "Not Detected",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/02/0990",
        "sampleDescription": "DIP26021107",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26021107",
        "resultValue": "5.6 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/02/1031",
        "sampleDescription": "DIP26021147",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26021147",
        "resultValue": "5.5 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/02/1051",
        "sampleDescription": "DIP26021171",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26021171",
        "resultValue": "5.8 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/02/1069",
        "sampleDescription": "DIP26021197",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26021197",
        "resultValue": "5.6 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/02/1115",
        "sampleDescription": "DIP26021243",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26021243",
        "resultValue": "5.4 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/02/1146",
        "sampleDescription": "DIP26021267",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26021267",
        "resultValue": "5.0 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/02/1181",
        "sampleDescription": "DIP26021293",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26021293",
        "resultValue": "5.3 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/02/1234",
        "sampleDescription": "DIP26021351",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26021351",
        "resultValue": "2.2 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/02/1315",
        "sampleDescription": "DIP26021440",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26021440",
        "resultValue": "0.05 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26004",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/02/1415",
        "sampleDescription": "DIP26021545",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26021545",
        "resultValue": "0.04 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26004"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26004",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/02/1459",
        "sampleDescription": "DIP26021590",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26021590",
        "resultValue": "0.06 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26004"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-B",
        "sampleID": "D/IM/26/02/1485",
        "sampleDescription": "DIP26021654",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26021654",
        "resultValue": "0.0006",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity of Stage-C.",
        "sampleID": "D/IM/26/02/1485",
        "sampleDescription": "DIP26021654",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26021654",
        "resultValue": "0.774",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26004",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-B",
        "sampleID": "D/IM/26/02/1568",
        "sampleDescription": "DIP26021774",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26021774",
        "resultValue": "0.0001",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26004"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26004",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity of Stage-C.",
        "sampleID": "D/IM/26/02/1568",
        "sampleDescription": "DIP26021774",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26021774",
        "resultValue": "0.691",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26004"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity",
        "sampleID": "D/IM/26/02/1664",
        "sampleDescription": "DIP26021895",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26021895",
        "resultValue": "0.973",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of benzophenone hydrazine",
        "sampleID": "D/IM/26/02/1664",
        "sampleDescription": "DIP26021895",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26021895",
        "resultValue": "0.0091",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-C dimer impurity",
        "sampleID": "D/IM/26/02/1664",
        "sampleDescription": "DIP26021895",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26021895",
        "resultValue": "0.0011",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/02/1874",
        "sampleDescription": "DIP26022031",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022031",
        "resultValue": "2.4 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26005",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/02/1875",
        "sampleDescription": "DIP26022032",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022032",
        "resultValue": "0.07 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26005"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/02/1898",
        "sampleDescription": "DIP26022064",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022064",
        "resultValue": "2.5 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26004",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/02/1901",
        "sampleDescription": "DIP26022069",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022069",
        "resultValue": "0.05 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26004"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26004",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/02/1902",
        "sampleDescription": "DIP26022070",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022070",
        "resultValue": "0.06 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26004"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/02/1927",
        "sampleDescription": "DIP26022093",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022093",
        "resultValue": "5.3 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/02/1954",
        "sampleDescription": "DIP26022120",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022120",
        "resultValue": "6.1 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/02/1986",
        "sampleDescription": "DIP26022145",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022145",
        "resultValue": "5.1 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/02/2006",
        "sampleDescription": "DIP26022169",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022169",
        "resultValue": "4.7 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/02/2029",
        "sampleDescription": "DIP26022198",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022198",
        "resultValue": "4.4 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26005",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-B",
        "sampleID": "D/IM/26/02/1987",
        "sampleDescription": "DIP26022223",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022223",
        "resultValue": "0.0004",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26005"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26005",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity of Stage-C.",
        "sampleID": "D/IM/26/02/1987",
        "sampleDescription": "DIP26022223",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022223",
        "resultValue": "0.68",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26005"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/02/2053",
        "sampleDescription": "DIP26022232",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022232",
        "resultValue": "8.2 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/02/2099",
        "sampleDescription": "DIP26022267",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022267",
        "resultValue": "4.9 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26004",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity",
        "sampleID": "D/IM/26/02/1989",
        "sampleDescription": "DIP26022305",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022305",
        "resultValue": "0.986",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26004"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26004",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of benzophenone hydrazine",
        "sampleID": "D/IM/26/02/1989",
        "sampleDescription": "DIP26022305",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022305",
        "resultValue": "0.001",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26004"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26004",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-C dimer impurity",
        "sampleID": "D/IM/26/02/1989",
        "sampleDescription": "DIP26022305",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022305",
        "resultValue": "Not Detected",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26004"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/02/2168",
        "sampleDescription": "DIP26022347",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022347",
        "resultValue": "4.5 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26006",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/02/2232",
        "sampleDescription": "DIP26022409",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022409",
        "resultValue": "0.06 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26006"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26006",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/02/2233",
        "sampleDescription": "DIP26022410",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022410",
        "resultValue": "0.06 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26006"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26006",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/02/2298",
        "sampleDescription": "DIP26022473",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022473",
        "resultValue": "0.09 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26006"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26004",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/02/2337",
        "sampleDescription": "DIP26022511",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022511",
        "resultValue": "1.9 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26004"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26004",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/02/2368",
        "sampleDescription": "DIP26022547",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022547",
        "resultValue": "0.87 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26004"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26006",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-B",
        "sampleID": "D/IM/26/02/2333",
        "sampleDescription": "DIP26022564",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022564",
        "resultValue": "Not Detected",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26006"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26006",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity of Stage-C.",
        "sampleID": "D/IM/26/02/2333",
        "sampleDescription": "DIP26022564",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022564",
        "resultValue": "0.698",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26006"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/02/2493",
        "sampleDescription": "DIP26022673",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022673",
        "resultValue": "0.06 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26007",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/02/2523",
        "sampleDescription": "DIP26022700",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26022700",
        "resultValue": "0.06 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26007"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26005",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity",
        "sampleID": "D/IM/26/02/2466",
        "sampleDescription": "DIP26030005",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030005",
        "resultValue": "0.971",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26005"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26005",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of benzophenone hydrazine",
        "sampleID": "D/IM/26/02/2466",
        "sampleDescription": "DIP26030005",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030005",
        "resultValue": "0.0033",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26005"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26005",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-C dimer impurity",
        "sampleID": "D/IM/26/02/2466",
        "sampleDescription": "DIP26030005",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030005",
        "resultValue": "Not Detected",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26005"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/03/0081",
        "sampleDescription": "DIP26030075",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030075",
        "resultValue": "0.05 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26005",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/03/0158",
        "sampleDescription": "DIP26030148",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030148",
        "resultValue": "1.1 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26005"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-B",
        "sampleID": "D/IM/26/03/0083",
        "sampleDescription": "DIP26030177",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030177",
        "resultValue": "0.0007",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity of Stage-C.",
        "sampleID": "D/IM/26/03/0083",
        "sampleDescription": "DIP26030177",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030177",
        "resultValue": "0.461",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26007",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-B",
        "sampleID": "D/IM/26/03/0176",
        "sampleDescription": "DIP26030230",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030230",
        "resultValue": "Not Detected",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26007"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26007",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity of Stage-C.",
        "sampleID": "D/IM/26/03/0176",
        "sampleDescription": "DIP26030230",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030230",
        "resultValue": "0.747",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26007"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26006",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/03/0364",
        "sampleDescription": "DIP26030346",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030346",
        "resultValue": "0.06 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26006"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26007",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity",
        "sampleID": "D/IM/26/03/0413",
        "sampleDescription": "DIP26030531",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030531",
        "resultValue": "0.963",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26007"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26007",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of benzophenone hydrazine",
        "sampleID": "D/IM/26/03/0413",
        "sampleDescription": "DIP26030531",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030531",
        "resultValue": "0.0019",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26007"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26007",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-C dimer impurity",
        "sampleID": "D/IM/26/03/0413",
        "sampleDescription": "DIP26030531",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030531",
        "resultValue": "Not Detected",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26007"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26006",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity",
        "sampleID": "D/IM/26/03/0487",
        "sampleDescription": "DIP26030543",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030543",
        "resultValue": "0.972",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26006"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26006",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of benzophenone hydrazine",
        "sampleID": "D/IM/26/03/0487",
        "sampleDescription": "DIP26030543",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030543",
        "resultValue": "Not Detected",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26006"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26006",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-C dimer impurity",
        "sampleID": "D/IM/26/03/0487",
        "sampleDescription": "DIP26030543",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030543",
        "resultValue": "Not Detected",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26006"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26009",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/03/0599",
        "sampleDescription": "DIP26030583",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030583",
        "resultValue": "0.06 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26009"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26009",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/03/0600",
        "sampleDescription": "DIP26030585",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030585",
        "resultValue": "0.06 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26009"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26007",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/03/0656",
        "sampleDescription": "DIP26030636",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030636",
        "resultValue": "0.96 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26007"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26006",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/03/0681",
        "sampleDescription": "DIP26030650",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030650",
        "resultValue": "0.70 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26006"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/03/0706",
        "sampleDescription": "DIP26030675",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030675",
        "resultValue": "0.05 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/03/0707",
        "sampleDescription": "DIP26030676",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030676",
        "resultValue": "0.06 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26009",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-B",
        "sampleID": "D/IM/26/03/0659",
        "sampleDescription": "DIP26030681",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030681",
        "resultValue": "Not Detected",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26009"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26009",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity of Stage-C.",
        "sampleID": "D/IM/26/03/0659",
        "sampleDescription": "DIP26030681",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030681",
        "resultValue": "0.767",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26009"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26009",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/03/0774",
        "sampleDescription": "DIP26030754",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030754",
        "resultValue": "0.05 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26009"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity",
        "sampleID": "D/IM/26/03/0703",
        "sampleDescription": "DIP26030791",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030791",
        "resultValue": "0.974",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of benzophenone hydrazine",
        "sampleID": "D/IM/26/03/0703",
        "sampleDescription": "DIP26030791",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030791",
        "resultValue": "Not Detected",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-C dimer impurity",
        "sampleID": "D/IM/26/03/0703",
        "sampleDescription": "DIP26030791",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030791",
        "resultValue": "Not Detected",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26010",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/03/0903",
        "sampleDescription": "DIP26030870",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030870",
        "resultValue": "0.06 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26010"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/03/1003",
        "sampleDescription": "DIP26030963",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26030963",
        "resultValue": "0.58 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26010",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-B",
        "sampleID": "D/IM/26/03/1001",
        "sampleDescription": "DIP26031033",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26031033",
        "resultValue": "0.0017",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26010"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26010",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity of Stage-C.",
        "sampleID": "D/IM/26/03/1001",
        "sampleDescription": "DIP26031033",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26031033",
        "resultValue": "0.62",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26010"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26011",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/03/1190",
        "sampleDescription": "DIP26031148",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26031148",
        "resultValue": "0.04 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26011"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26011",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/03/1191",
        "sampleDescription": "DIP26031149",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26031149",
        "resultValue": "0.05 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26011"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26009",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity",
        "sampleID": "D/IM/26/03/1185",
        "sampleDescription": "DIP26031211",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26031211",
        "resultValue": "0.976",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26009"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26009",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of benzophenone hydrazine",
        "sampleID": "D/IM/26/03/1185",
        "sampleDescription": "DIP26031211",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26031211",
        "resultValue": "Not Detected",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26009"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26009",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-C dimer impurity",
        "sampleID": "D/IM/26/03/1185",
        "sampleDescription": "DIP26031211",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26031211",
        "resultValue": "0.0009",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26009"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26011",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-B",
        "sampleID": "D/IM/26/03/1240",
        "sampleDescription": "DIP26031233",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26031233",
        "resultValue": "0.002",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26011"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26011",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity of Stage-C.",
        "sampleID": "D/IM/26/03/1240",
        "sampleDescription": "DIP26031233",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26031233",
        "resultValue": "0.772",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26011"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26010",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/03/1327",
        "sampleDescription": "DIP26031280",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26031280",
        "resultValue": "0.04 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26010"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26010",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/03/1381",
        "sampleDescription": "DIP26031330",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26031330",
        "resultValue": "0.07 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26010"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26009",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/03/1421",
        "sampleDescription": "DIP26031365",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26031365",
        "resultValue": "0.49 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26009"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26012",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/03/1508",
        "sampleDescription": "DIP26031460",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26031460",
        "resultValue": "0.08 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26012"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26010",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity",
        "sampleID": "D/IM/26/03/1428",
        "sampleDescription": "DIP26031507",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26031507",
        "resultValue": "0.981",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26010"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26010",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of benzophenone hydrazine",
        "sampleID": "D/IM/26/03/1428",
        "sampleDescription": "DIP26031507",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26031507",
        "resultValue": "Not Detected",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26010"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26010",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-C dimer impurity",
        "sampleID": "D/IM/26/03/1428",
        "sampleDescription": "DIP26031507",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26031507",
        "resultValue": "Not Detected",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26010"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26011",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/03/1647",
        "sampleDescription": "DIP26031607",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26031607",
        "resultValue": "0.04 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26011"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26012",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-B",
        "sampleID": "D/IM/26/03/1532",
        "sampleDescription": "DIP26031631",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26031631",
        "resultValue": "0",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26012"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26012",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity of Stage-C.",
        "sampleID": "D/IM/26/03/1532",
        "sampleDescription": "DIP26031631",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26031631",
        "resultValue": "0.773",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26012"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26010",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/03/1739",
        "sampleDescription": "DIP26031696",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26031696",
        "resultValue": "0.51 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26010"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26011",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity",
        "sampleID": "D/IM/26/03/1747",
        "sampleDescription": "DIP26031826",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26031826",
        "resultValue": "0.981",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26011"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26011",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of benzophenone hydrazine",
        "sampleID": "D/IM/26/03/1747",
        "sampleDescription": "DIP26031826",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26031826",
        "resultValue": "0.0006",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26011"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26011",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-C dimer impurity",
        "sampleID": "D/IM/26/03/1747",
        "sampleDescription": "DIP26031826",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26031826",
        "resultValue": "0.0009",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26011"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Hydrazine in Stage-C filtrate mL’s by GC-HS (ppm)",
        "sampleID": "D/IM/26/03/1964",
        "sampleDescription": "DIP26031940",
        "specificationLimit": "Not more than 200",
        "analyticalReportNumber": "DIP26031940",
        "resultValue": "2.4 ppm",
        "result": "Pass",
        "cqas": "",
        "uom": "ppm",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26012",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Water content of Isopropyl alcohol by KF (% w/v)",
        "sampleID": "D/IM/26/03/2040",
        "sampleDescription": "DIP26032009",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26032009",
        "resultValue": "0.07 % w/v",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/v",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26012"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26011",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/03/2039",
        "sampleDescription": "DIP26032081",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26032081",
        "resultValue": "0.48 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26011"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26012",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Purity",
        "sampleID": "D/IM/26/03/1942",
        "sampleDescription": "DIP26032141",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26032141",
        "resultValue": "0.977",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26012"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26012",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of benzophenone hydrazine",
        "sampleID": "D/IM/26/03/1942",
        "sampleDescription": "DIP26032141",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26032141",
        "resultValue": "0.0006",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26012"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26012",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Content of Stage-C dimer impurity",
        "sampleID": "D/IM/26/03/1942",
        "sampleDescription": "DIP26032141",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26032141",
        "resultValue": "0.0009",
        "result": "Pass",
        "cqas": "",
        "uom": "%",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26012"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26012",
        "procedureNumber": "",
        "methodNumber": "BSQ-IP-03/00",
        "methodName": "Loss on drying of Stage-C (% w/w)",
        "sampleID": "D/IM/26/03/2378",
        "sampleDescription": "DIP26032361",
        "specificationLimit": "Report the result",
        "analyticalReportNumber": "DIP26032361",
        "resultValue": "0.58 % w/w",
        "result": "Pass",
        "cqas": "",
        "uom": "% w/w",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26012"
    }
],
  3: [
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Description",
        "sampleID": "D/IM/26/01/0930",
        "sampleDescription": "DIMCBSQ260001",
        "specificationLimit": "Report the observation",
        "arNumber": "DIMCBSQ260001",
        "resultValue": "pale  brown color solid ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Identification by UPLC",
        "sampleID": "D/IM/26/01/0930",
        "sampleDescription": "DIMCBSQ260001",
        "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
        "arNumber": "DIMCBSQ260001",
        "resultValue": "Complies ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Loss on drying (% w/w)",
        "sampleID": "D/IM/26/01/0930",
        "sampleDescription": "DIMCBSQ260001",
        "specificationLimit": "Not more than 2.0",
        "arNumber": "DIMCBSQ260001",
        "resultValue": "0.6",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Chromatographic purity by UPLC (% area)",
        "sampleID": "D/IM/26/01/0930",
        "sampleDescription": "DIMCBSQ260001",
        "specificationLimit": "Not less than 90.0",
        "arNumber": "DIMCBSQ260001",
        "resultValue": "0.974",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Assay by UPLC (% w/w, as is basis)",
        "sampleID": "D/IM/26/01/0930",
        "sampleDescription": "DIMCBSQ260001",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260001",
        "resultValue": "93.8 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Assay by UPLC (% w/w)(on dried basis)",
        "sampleID": "D/IM/26/01/0930",
        "sampleDescription": "DIMCBSQ260001",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260001",
        "resultValue": "94.4 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Description",
        "sampleID": "D/IM/26/02/1354",
        "sampleDescription": "DIMCBSQ260002",
        "specificationLimit": "Report the observation",
        "arNumber": "DIMCBSQ260002",
        "resultValue": "Pale brown color solid ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Identification by UPLC",
        "sampleID": "D/IM/26/02/1354",
        "sampleDescription": "DIMCBSQ260002",
        "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
        "arNumber": "DIMCBSQ260002",
        "resultValue": "Complies ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Loss on drying (% w/w)",
        "sampleID": "D/IM/26/02/1354",
        "sampleDescription": "DIMCBSQ260002",
        "specificationLimit": "Not more than 2.0",
        "arNumber": "DIMCBSQ260002",
        "resultValue": "3.2 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Chromatographic purity by UPLC (% area)",
        "sampleID": "D/IM/26/02/1354",
        "sampleDescription": "DIMCBSQ260002",
        "specificationLimit": "Not less than 90.0",
        "arNumber": "DIMCBSQ260002",
        "resultValue": "0.959",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Assay by UPLC (% w/w, as is basis)",
        "sampleID": "D/IM/26/02/1354",
        "sampleDescription": "DIMCBSQ260002",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260002",
        "resultValue": "89.3 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Assay by UPLC (% w/w)(on dried basis)",
        "sampleID": "D/IM/26/02/1354",
        "sampleDescription": "DIMCBSQ260002",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260002",
        "resultValue": "92.3 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Use test",
        "sampleID": "D/IM/26/02/1354",
        "sampleDescription": "DIMCBSQ260002",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260002",
        "resultValue": "Complies ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26004",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Description",
        "sampleID": "D/IM/26/02/2455",
        "sampleDescription": "DIMCBSQ260003",
        "specificationLimit": "Report the observation",
        "arNumber": "DIMCBSQ260003",
        "resultValue": "pale yellow color solid ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26004"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26004",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Identification by UPLC",
        "sampleID": "D/IM/26/02/2455",
        "sampleDescription": "DIMCBSQ260003",
        "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
        "arNumber": "DIMCBSQ260003",
        "resultValue": "Complies ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26004"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26004",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Loss on drying (% w/w)",
        "sampleID": "D/IM/26/02/2455",
        "sampleDescription": "DIMCBSQ260003",
        "specificationLimit": "Not more than 2.0",
        "arNumber": "DIMCBSQ260003",
        "resultValue": "0.27 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26004"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26004",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Chromatographic purity by UPLC (% area)",
        "sampleID": "D/IM/26/02/2455",
        "sampleDescription": "DIMCBSQ260003",
        "specificationLimit": "Not less than 90.0",
        "arNumber": "DIMCBSQ260003",
        "resultValue": "0.98",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26004"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26004",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Assay by UPLC (% w/w, as is basis)",
        "sampleID": "D/IM/26/02/2455",
        "sampleDescription": "DIMCBSQ260003",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260003",
        "resultValue": "94.6 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26004"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26004",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Assay by UPLC (% w/w)(on dried basis)",
        "sampleID": "D/IM/26/02/2455",
        "sampleDescription": "DIMCBSQ260003",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260003",
        "resultValue": "94.9 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26004"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Description",
        "sampleID": "D/IM/26/02/2497",
        "sampleDescription": "DIMCBSQ260004",
        "specificationLimit": "Report the observation",
        "arNumber": "DIMCBSQ260004",
        "resultValue": "Pale yellow color solid ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Identification by UPLC",
        "sampleID": "D/IM/26/02/2497",
        "sampleDescription": "DIMCBSQ260004",
        "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
        "arNumber": "DIMCBSQ260004",
        "resultValue": "Complies ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Loss on drying (% w/w)",
        "sampleID": "D/IM/26/02/2497",
        "sampleDescription": "DIMCBSQ260004",
        "specificationLimit": "Not more than 2.0",
        "arNumber": "DIMCBSQ260004",
        "resultValue": "3.9 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Chromatographic purity by UPLC (% area)",
        "sampleID": "D/IM/26/02/2497",
        "sampleDescription": "DIMCBSQ260004",
        "specificationLimit": "Not less than 90.0",
        "arNumber": "DIMCBSQ260004",
        "resultValue": "0.962",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Assay by UPLC (% w/w, as is basis)",
        "sampleID": "D/IM/26/02/2497",
        "sampleDescription": "DIMCBSQ260004",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260004",
        "resultValue": "94.7 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Assay by UPLC (% w/w)(on dried basis)",
        "sampleID": "D/IM/26/02/2497",
        "sampleDescription": "DIMCBSQ260004",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260004",
        "resultValue": "98.5 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Use test",
        "sampleID": "D/IM/26/02/2497",
        "sampleDescription": "DIMCBSQ260004",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260004",
        "resultValue": "Complies ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26005",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Description",
        "sampleID": "D/IM/26/03/0240",
        "sampleDescription": "DIMCBSQ260005",
        "specificationLimit": "Report the observation",
        "arNumber": "DIMCBSQ260005",
        "resultValue": "pale yellow color solid ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26005"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26005",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Identification by UPLC",
        "sampleID": "D/IM/26/03/0240",
        "sampleDescription": "DIMCBSQ260005",
        "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
        "arNumber": "DIMCBSQ260005",
        "resultValue": "Complies ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26005"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26005",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Loss on drying (% w/w)",
        "sampleID": "D/IM/26/03/0240",
        "sampleDescription": "DIMCBSQ260005",
        "specificationLimit": "Not more than 2.0",
        "arNumber": "DIMCBSQ260005",
        "resultValue": "1.0 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26005"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26005",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Chromatographic purity by UPLC (% area)",
        "sampleID": "D/IM/26/03/0240",
        "sampleDescription": "DIMCBSQ260005",
        "specificationLimit": "Not less than 90.0",
        "arNumber": "DIMCBSQ260005",
        "resultValue": "0.978",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26005"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26005",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Assay by UPLC (% w/w, as is basis)",
        "sampleID": "D/IM/26/03/0240",
        "sampleDescription": "DIMCBSQ260005",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260005",
        "resultValue": "93.1 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26005"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26005",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Assay by UPLC (% w/w)(on dried basis)",
        "sampleID": "D/IM/26/03/0240",
        "sampleDescription": "DIMCBSQ260005",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260005",
        "resultValue": "94.1 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26005"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26007",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Description",
        "sampleID": "D/IM/26/03/0726",
        "sampleDescription": "DIMCBSQ260006",
        "specificationLimit": "Report the observation",
        "arNumber": "DIMCBSQ260006",
        "resultValue": "Pale yellow color solid ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26007"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26007",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Identification by UPLC",
        "sampleID": "D/IM/26/03/0726",
        "sampleDescription": "DIMCBSQ260006",
        "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
        "arNumber": "DIMCBSQ260006",
        "resultValue": "Complies ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26007"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26007",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Loss on drying (% w/w)",
        "sampleID": "D/IM/26/03/0726",
        "sampleDescription": "DIMCBSQ260006",
        "specificationLimit": "Not more than 2.0",
        "arNumber": "DIMCBSQ260006",
        "resultValue": "0.90 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26007"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26007",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Chromatographic purity by UPLC (% area)",
        "sampleID": "D/IM/26/03/0726",
        "sampleDescription": "DIMCBSQ260006",
        "specificationLimit": "Not less than 90.0",
        "arNumber": "DIMCBSQ260006",
        "resultValue": "96.8",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26007"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26007",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Assay by UPLC (% w/w, as is basis)",
        "sampleID": "D/IM/26/03/0726",
        "sampleDescription": "DIMCBSQ260006",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260006",
        "resultValue": "90.3 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26007"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26007",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Assay by UPLC (% w/w)(on dried basis)",
        "sampleID": "D/IM/26/03/0726",
        "sampleDescription": "DIMCBSQ260006",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260006",
        "resultValue": "91.1 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26007"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26006",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Description",
        "sampleID": "D/IM/26/03/0790",
        "sampleDescription": "DIMCBSQ260007",
        "specificationLimit": "Report the observation",
        "arNumber": "DIMCBSQ260007",
        "resultValue": "Pale yellow color solid ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26006"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26006",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Identification by UPLC",
        "sampleID": "D/IM/26/03/0790",
        "sampleDescription": "DIMCBSQ260007",
        "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
        "arNumber": "DIMCBSQ260007",
        "resultValue": "Complies ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26006"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26006",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Loss on drying (% w/w)",
        "sampleID": "D/IM/26/03/0790",
        "sampleDescription": "DIMCBSQ260007",
        "specificationLimit": "Not more than 2.0",
        "arNumber": "DIMCBSQ260007",
        "resultValue": "0.66 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26006"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26006",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Chromatographic purity by UPLC (% area)",
        "sampleID": "D/IM/26/03/0790",
        "sampleDescription": "DIMCBSQ260007",
        "specificationLimit": "Not less than 90.0",
        "arNumber": "DIMCBSQ260007",
        "resultValue": "0.965",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26006"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26006",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Assay by UPLC (% w/w, as is basis)",
        "sampleID": "D/IM/26/03/0790",
        "sampleDescription": "DIMCBSQ260007",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260007",
        "resultValue": "91.0 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26006"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26006",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Assay by UPLC (% w/w)(on dried basis)",
        "sampleID": "D/IM/26/03/0790",
        "sampleDescription": "DIMCBSQ260007",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260007",
        "resultValue": "91.6 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26006"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Description",
        "sampleID": "D/IM/26/03/1149",
        "sampleDescription": "DIMCBSQ260008",
        "specificationLimit": "Report the observation",
        "arNumber": "DIMCBSQ260008",
        "resultValue": "Pale yellow color solid ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Identification by UPLC",
        "sampleID": "D/IM/26/03/1149",
        "sampleDescription": "DIMCBSQ260008",
        "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
        "arNumber": "DIMCBSQ260008",
        "resultValue": "Complies ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Loss on drying (% w/w)",
        "sampleID": "D/IM/26/03/1149",
        "sampleDescription": "DIMCBSQ260008",
        "specificationLimit": "Not more than 2.0",
        "arNumber": "DIMCBSQ260008",
        "resultValue": "0.21 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Chromatographic purity by UPLC (% area)",
        "sampleID": "D/IM/26/03/1149",
        "sampleDescription": "DIMCBSQ260008",
        "specificationLimit": "Not less than 90.0",
        "arNumber": "DIMCBSQ260008",
        "resultValue": "97.7",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Assay by UPLC (% w/w, as is basis)",
        "sampleID": "D/IM/26/03/1149",
        "sampleDescription": "DIMCBSQ260008",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260008",
        "resultValue": "94.3 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Assay by UPLC (% w/w)(on dried basis)",
        "sampleID": "D/IM/26/03/1149",
        "sampleDescription": "DIMCBSQ260008",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260008",
        "resultValue": "94.5 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26009",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Description",
        "sampleID": "D/IM/26/03/1577",
        "sampleDescription": "DIMCBSQ260009",
        "specificationLimit": "Report the observation",
        "arNumber": "DIMCBSQ260009",
        "resultValue": "Pale yellow color solid ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26009"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26009",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Identification by UPLC",
        "sampleID": "D/IM/26/03/1577",
        "sampleDescription": "DIMCBSQ260009",
        "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
        "arNumber": "DIMCBSQ260009",
        "resultValue": "Complies ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26009"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26009",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Loss on drying (% w/w)",
        "sampleID": "D/IM/26/03/1577",
        "sampleDescription": "DIMCBSQ260009",
        "specificationLimit": "Not more than 2.0",
        "arNumber": "DIMCBSQ260009",
        "resultValue": "0.65 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26009"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26009",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Chromatographic purity by UPLC (% area)",
        "sampleID": "D/IM/26/03/1577",
        "sampleDescription": "DIMCBSQ260009",
        "specificationLimit": "Not less than 90.0",
        "arNumber": "DIMCBSQ260009",
        "resultValue": "0.98",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26009"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26009",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Assay by UPLC (% w/w, as is basis)",
        "sampleID": "D/IM/26/03/1577",
        "sampleDescription": "DIMCBSQ260009",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260009",
        "resultValue": "95.1 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26009"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26009",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Assay by UPLC (% w/w)(on dried basis)",
        "sampleID": "D/IM/26/03/1577",
        "sampleDescription": "DIMCBSQ260009",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260009",
        "resultValue": "95.8 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26009"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26010",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Description",
        "sampleID": "D/IM/26/03/1875",
        "sampleDescription": "DIMCBSQ260010",
        "specificationLimit": "Report the observation",
        "arNumber": "DIMCBSQ260010",
        "resultValue": "Pale yellow color solid ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26010"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26010",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Identification by UPLC",
        "sampleID": "D/IM/26/03/1875",
        "sampleDescription": "DIMCBSQ260010",
        "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
        "arNumber": "DIMCBSQ260010",
        "resultValue": "Complies ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26010"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26010",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Loss on drying (% w/w)",
        "sampleID": "D/IM/26/03/1875",
        "sampleDescription": "DIMCBSQ260010",
        "specificationLimit": "Not more than 2.0",
        "arNumber": "DIMCBSQ260010",
        "resultValue": "2.3 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26010"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26010",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Chromatographic purity by UPLC (% area)",
        "sampleID": "D/IM/26/03/1875",
        "sampleDescription": "DIMCBSQ260010",
        "specificationLimit": "Not less than 90.0",
        "arNumber": "DIMCBSQ260010",
        "resultValue": "0.985",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26010"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26010",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Assay by UPLC (% w/w, as is basis)",
        "sampleID": "D/IM/26/03/1875",
        "sampleDescription": "DIMCBSQ260010",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260010",
        "resultValue": "91.8 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26010"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26010",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Assay by UPLC (% w/w)(on dried basis)",
        "sampleID": "D/IM/26/03/1875",
        "sampleDescription": "DIMCBSQ260010",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260010",
        "resultValue": "94.0 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26010"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26010",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Use test",
        "sampleID": "D/IM/26/03/1875",
        "sampleDescription": "DIMCBSQ260010",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260010",
        "resultValue": "Complies ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26010"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26011",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Description",
        "sampleID": "D/IM/26/03/2235",
        "sampleDescription": "DIMCBSQ260011",
        "specificationLimit": "Report the observation",
        "arNumber": "DIMCBSQ260011",
        "resultValue": "Pale yellow color solid ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26011"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26011",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Identification by UPLC",
        "sampleID": "D/IM/26/03/2235",
        "sampleDescription": "DIMCBSQ260011",
        "specificationLimit": "In the test for “Assay by UPLC (% w/w, as is basis)”, the retention time of the main peak in the sample solution should correspond to that of the main peak in the standard solution.",
        "arNumber": "DIMCBSQ260011",
        "resultValue": "Complies ",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26011"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26011",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Loss on drying (% w/w)",
        "sampleID": "D/IM/26/03/2235",
        "sampleDescription": "DIMCBSQ260011",
        "specificationLimit": "Not more than 2.0",
        "arNumber": "DIMCBSQ260011",
        "resultValue": "0.23 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26011"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26011",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Chromatographic purity by UPLC (% area)",
        "sampleID": "D/IM/26/03/2235",
        "sampleDescription": "DIMCBSQ260011",
        "specificationLimit": "Not less than 90.0",
        "arNumber": "DIMCBSQ260011",
        "resultValue": "0.975",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26011"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26011",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Assay by UPLC (% w/w, as is basis)",
        "sampleID": "D/IM/26/03/2235",
        "sampleDescription": "DIMCBSQ260011",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260011",
        "resultValue": "95.1 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26011"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26011",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "Assay by UPLC (% w/w)(on dried basis)",
        "sampleID": "D/IM/26/03/2235",
        "sampleDescription": "DIMCBSQ260011",
        "specificationLimit": "Report the result",
        "arNumber": "DIMCBSQ260011",
        "resultValue": "95.3 % w/w",
        "result": "Pass",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26011"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26012",
        "procedureNumber": "",
        "methodNumber": "BSQ-IN-03/00",
        "methodName": "",
        "sampleID": "D/IM/26/03/2467",
        "sampleDescription": "DIMCBSQ260012",
        "specificationLimit": "",
        "arNumber": "DIMCBSQ260012",
        "resultValue": "",
        "result": "N/A",
        "cqas": "",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26012"
    }
],
  4: [
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "equipment": "DSSR84",
        "location": "Production Block - 11",
        "equipmentType": "REACTOR",
        "equipmentTitle": "SS REACTOR",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "equipment": "DGLB37",
        "location": "Production Block - 11",
        "equipmentType": "GLOVE BOX",
        "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "equipment": "DNFD25-1",
        "location": "Production Block - 11",
        "equipmentType": "DRYER",
        "equipmentTitle": "AGITATED NUTSCHE FILTER DRYER",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "equipment": "DSNF41",
        "location": "Production Block - 07",
        "equipmentType": "FILTER",
        "equipmentTitle": "SS (ROBO) NUTSCHE FILTER",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "equipment": "DNFD25-1",
        "location": "Production Block - 11",
        "equipmentType": "DRYER",
        "equipmentTitle": "AGITATED NUTSCHE FILTER DRYER",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "equipment": "DSSR81",
        "location": "Production Block - 11",
        "equipmentType": "REACTOR",
        "equipmentTitle": "SS REACTOR",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC25001",
        "equipment": "DGLB32",
        "location": "Production Block - 08",
        "equipmentType": "GLOVE BOX",
        "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC25001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "equipment": "DSSR81",
        "location": "Production Block - 11",
        "equipmentType": "REACTOR",
        "equipmentTitle": "SS REACTOR",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "equipment": "DGLB32",
        "location": "Production Block - 08",
        "equipmentType": "GLOVE BOX",
        "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26001",
        "equipment": "DNFD45",
        "location": "Production Block - 11",
        "equipmentType": "DRYER",
        "equipmentTitle": "AGITATED NUTSCHE FILTER DRYER",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26001"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "equipment": "DSSR81",
        "location": "Production Block - 11",
        "equipmentType": "REACTOR",
        "equipmentTitle": "SS REACTOR",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "equipment": "DGLB32",
        "location": "Production Block - 08",
        "equipmentType": "GLOVE BOX",
        "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26003",
        "equipment": "DNFD45",
        "location": "Production Block - 11",
        "equipmentType": "DRYER",
        "equipmentTitle": "AGITATED NUTSCHE FILTER DRYER",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26003"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26004",
        "equipment": "DGLR64",
        "location": "Production Block - 07",
        "equipmentType": "REACTOR",
        "equipmentTitle": "GL REACTOR",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26004"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26004",
        "equipment": "DGLB29",
        "location": "Production Block - 07",
        "equipmentType": "GLOVE BOX",
        "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26004"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26004",
        "equipment": "DSCF15",
        "location": "Production Block - 07",
        "equipmentType": "CENTRIFUGE",
        "equipmentTitle": "SS PVDF LINED CENTRIFUGE",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26004"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26004",
        "equipment": "DGLB04-1",
        "location": "Production Block - 07",
        "equipmentType": "GLOVE BOX",
        "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26004"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26004",
        "equipment": "DRVD08",
        "location": "Production Block - 07",
        "equipmentType": "DRYER",
        "equipmentTitle": "SS ROTOCONE VACUUM DRYER",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26004"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26005",
        "equipment": "DSSR81",
        "location": "Production Block - 11",
        "equipmentType": "REACTOR",
        "equipmentTitle": "SS REACTOR",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26005"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26005",
        "equipment": "DGLB32",
        "location": "Production Block - 08",
        "equipmentType": "GLOVE BOX",
        "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26005"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26005",
        "equipment": "DNFD45",
        "location": "Production Block - 11",
        "equipmentType": "DRYER",
        "equipmentTitle": "AGITATED NUTSCHE FILTER DRYER",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26005"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26006",
        "equipment": "DGLR64",
        "location": "Production Block - 07",
        "equipmentType": "REACTOR",
        "equipmentTitle": "GL REACTOR",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26006"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26006",
        "equipment": "DGLB04-1",
        "location": "Production Block - 07",
        "equipmentType": "GLOVE BOX",
        "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26006"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26006",
        "equipment": "DSCF15",
        "location": "Production Block - 07",
        "equipmentType": "CENTRIFUGE",
        "equipmentTitle": "SS PVDF LINED CENTRIFUGE",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26006"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26006",
        "equipment": "DGLR64",
        "location": "Production Block - 07",
        "equipmentType": "REACTOR",
        "equipmentTitle": "GL REACTOR",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26006"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26006",
        "equipment": "DGLB04-1",
        "location": "Production Block - 07",
        "equipmentType": "GLOVE BOX",
        "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26006"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26006",
        "equipment": "DRVD08",
        "location": "Production Block - 07",
        "equipmentType": "DRYER",
        "equipmentTitle": "SS ROTOCONE VACUUM DRYER",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26006"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26007",
        "equipment": "DSSR81",
        "location": "Production Block - 11",
        "equipmentType": "REACTOR",
        "equipmentTitle": "SS REACTOR",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26007"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26007",
        "equipment": "DGLB32",
        "location": "Production Block - 08",
        "equipmentType": "GLOVE BOX",
        "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26007"
    },
    {
        "campaignBatch": "CMPO04TEV169 / DBSQC26007",
        "equipment": "DNFD45",
        "location": "Production Block - 11",
        "equipmentType": "DRYER",
        "equipmentTitle": "AGITATED NUTSCHE FILTER DRYER",
        "campaignId": "CMPO04TEV169",
        "batchId": "DBSQC26007"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "equipment": "DSSR57",
        "location": "Production Block - 08",
        "equipmentType": "REACTOR",
        "equipmentTitle": "SS REACTOR",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "equipment": "DGLB05",
        "location": "Production Block - 07",
        "equipmentType": "GLOVE BOX",
        "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "equipment": "DSCF23",
        "location": "Production Block - 08",
        "equipmentType": "CENTRIFUGE",
        "equipmentTitle": "CENTRIFUGE",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "equipment": "DSCF18",
        "location": "Production Block - 08",
        "equipmentType": "CENTRIFUGE",
        "equipmentTitle": "CENTRIFUGE",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "equipment": "DGLB05",
        "location": "Production Block - 07",
        "equipmentType": "GLOVE BOX",
        "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26008",
        "equipment": "DRVD08",
        "location": "Production Block - 07",
        "equipmentType": "DRYER",
        "equipmentTitle": "SS ROTOCONE VACUUM DRYER",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26008"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26009",
        "equipment": "DGLR64",
        "location": "Production Block - 07",
        "equipmentType": "REACTOR",
        "equipmentTitle": "GL REACTOR",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26009"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26009",
        "equipment": "DGLB04-1",
        "location": "Production Block - 07",
        "equipmentType": "GLOVE BOX",
        "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26009"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26009",
        "equipment": "DSCF15",
        "location": "Production Block - 07",
        "equipmentType": "CENTRIFUGE",
        "equipmentTitle": "SS PVDF LINED CENTRIFUGE",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26009"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26009",
        "equipment": "DGLB04-1",
        "location": "Production Block - 07",
        "equipmentType": "GLOVE BOX",
        "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26009"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26009",
        "equipment": "DRVD08",
        "location": "Production Block - 07",
        "equipmentType": "DRYER",
        "equipmentTitle": "SS ROTOCONE VACUUM DRYER",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26009"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26010",
        "equipment": "DSSR57",
        "location": "Production Block - 08",
        "equipmentType": "REACTOR",
        "equipmentTitle": "SS REACTOR",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26010"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26010",
        "equipment": "DGLB05",
        "location": "Production Block - 07",
        "equipmentType": "GLOVE BOX",
        "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26010"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26010",
        "equipment": "DSCF23",
        "location": "Production Block - 08",
        "equipmentType": "CENTRIFUGE",
        "equipmentTitle": "CENTRIFUGE",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26010"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26010",
        "equipment": "DSCF18",
        "location": "Production Block - 08",
        "equipmentType": "CENTRIFUGE",
        "equipmentTitle": "CENTRIFUGE",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26010"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26010",
        "equipment": "DRVD08",
        "location": "Production Block - 07",
        "equipmentType": "DRYER",
        "equipmentTitle": "SS ROTOCONE VACUUM DRYER",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26010"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26011",
        "equipment": "DGLR64",
        "location": "Production Block - 07",
        "equipmentType": "REACTOR",
        "equipmentTitle": "GL REACTOR",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26011"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26011",
        "equipment": "DGLB04-1",
        "location": "Production Block - 07",
        "equipmentType": "GLOVE BOX",
        "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26011"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26011",
        "equipment": "DSCF15",
        "location": "Production Block - 07",
        "equipmentType": "CENTRIFUGE",
        "equipmentTitle": "SS PVDF LINED CENTRIFUGE",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26011"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26011",
        "equipment": "DGLB04-1",
        "location": "Production Block - 07",
        "equipmentType": "GLOVE BOX",
        "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26011"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26011",
        "equipment": "DRVD08",
        "location": "Production Block - 07",
        "equipmentType": "DRYER",
        "equipmentTitle": "SS ROTOCONE VACUUM DRYER",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26011"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26012",
        "equipment": "DSSR57",
        "location": "Production Block - 08",
        "equipmentType": "REACTOR",
        "equipmentTitle": "SS REACTOR",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26012"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26012",
        "equipment": "DGLB05",
        "location": "Production Block - 07",
        "equipmentType": "GLOVE BOX",
        "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26012"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26012",
        "equipment": "DSCF23",
        "location": "Production Block - 08",
        "equipmentType": "CENTRIFUGE",
        "equipmentTitle": "CENTRIFUGE",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26012"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26012",
        "equipment": "DSCF18",
        "location": "Production Block - 08",
        "equipmentType": "CENTRIFUGE",
        "equipmentTitle": "CENTRIFUGE",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26012"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26012",
        "equipment": "DGLB05",
        "location": "Production Block - 07",
        "equipmentType": "GLOVE BOX",
        "equipmentTitle": "REACTOR CHARGING GLOVE BOX",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26012"
    },
    {
        "campaignBatch": "CMPO04BRS729 / DBSQC26012",
        "equipment": "DRVD08",
        "location": "Production Block - 07",
        "equipmentType": "DRYER",
        "equipmentTitle": "SS ROTOCONE VACUUM DRYER",
        "campaignId": "CMPO04BRS729",
        "batchId": "DBSQC26012"
    }
],
};

export const fetchProjectAnalyticsDataAPI = async (projectId, stageId, campaignId, tabId, filters = {}) => {
  return {
    status: true,
    data: {
      projectId,
      stageId,
      campaignId,
      tabId,
      filters,
      rows: allTabData[tabId] || [],
      generatedAt: new Date().toISOString(),
    },
  };
};
